// Assembly: idxCommon
(function(window, document, undefined) {

  var langKeys = ["close","update_preference_message","batch_submitted","reindex_batch_returned","checkout_error","checkout_error_412","cancel","accept-terms-and-conditions-body","accept-terms-and-conditions","accept","exit_to_overview","content-agreement","batch_read_only_title","batch_read_only_description","super_user_batch_read_only_title","super_user_batch_read_only_description","super_user_batch_read_only_description_indexing_or_review","open_in_review","open_in_indexing","access_restricted_title","access_restricted_description","access_not_available_title","access_not_available_description","find_batches","indexing-terms","loading-image-data","loading-project-data","loading-record-data","loading-template-data","loading-user-data","loading-workflow-data","web_indexing","next_open_batch","no_available_batches","no_project_instructions","no_similar_batches","not-accept","okay","primary_button_text","project_instructions","review-terms","similar_batch","similar_review_batch","thank_you","try_again_button_text","updating_user_resource_error_body","updating_user_resource_error_heading","menu_batch","menu-review-mode","menu-batch-read-only","menu_return_batch","menu_submit_batch","menu_back_to_web_indexing","menu_edit","menu_edit_blocking_pattern","menu_edit_clear_batching_data","menu_edit_block_image","menu_edit_unblock_image","menu_edit_split_batch","menu_edit_join_next_batch","menu_edit_join_previous_batch","menu_view","menu_view_project_instructions","menu_view_image","menu_view_show_only_blocked_images","toggle_blocked_symbols","toggle_batch_numbers","toggle_batch_colors","menu_mode","menu_mode_block_mode","menu_mode_batch_mode","menu_mode_pattern_mode","menu_mode_rebatch_mode","menu_mode_clear_mode"];
  var langs = {
    // Included locale file: common_de.json
    "de": ["Schließen","Die Anweisungen für dieses Projekt nicht wieder anzeigen.","Der Satz wurde eingereicht. Vielleicht wollen Sie eine der Optionen unten auswählen.","Der Satz wurde zurückgesandt. Vielleicht wollen Sie eine der Optionen unten auswählen.","Beim Versuch, einen ähnlichen Satz herunterzuladen, ist leider ein Fehler aufgetreten. Bitte schließen und „Indexierung im Internet“ aufrufen.","Beim Anfordern eines Satzes ist ein Fehler aufgetreten. In diesem Projekt wurde die Anzahl der Sätze, die sich gleichzeitig in Bearbeitung befinden dürfen, begrenzt. Bitte suchen Sie sich ein anderes Projekt, in dem Sie Sätze bearbeiten können.","Abbrechen","Wenn Sie sich an der FamilySearch-Indexierung beteiligen möchten, müssen Sie den folgenden Nutzungsbedingungen zustimmen. Bitte lesen Sie sich jede Richtlinie durch und stimmen Sie ihr zu, ehe Sie fortfahren.","Bitte stimmen Sie den Nutzungsbedingungen zu","Ich stimme zu","Zur Übersicht zur Indexierung zurückkehren","Vereinbarung zur Einreichung von Inhalten bei FamilySearch","Einen zur Ansicht freigegebenen Satz öffnen","Sie sehen sich gerade einen zur Ansicht freigegebenen Satz an. Nichts, was Sie eingeben, wird gespeichert oder eingereicht.","Sie sehen sich einen zur Ansicht freigegebenen Satz als Admin an","Sie schauen sich einen Satz im Schreibschutz-Modus an. Nichts, was Sie eingeben, wird gespeichert oder eingereicht.","Sie schauen sich einen Satz im Schreibschutz-Modus an. Nichts, was Sie eingeben, wird gespeichert oder eingereicht. Möchten Sie sich den Satz im Indexierungs- oder im Prüfmodus anschauen?","Im Prüfmodus öffnen","Im Indexierungsmodus öffnen","Eingeschränkter Zugriff","Sie sind nicht berechtigt, diesen Satz zu öffnen. Bitte suchen Sie sich einen anderen Satz zur Bearbeitung aus.","Satz nicht verfügbar","Der Satz, auf den Sie zugreifen wollten, ist nicht verfügbar. Bitte suchen Sie sich einen anderen Satz zur Bearbeitung aus.","Sätze suchen","FamilySearch-Indexierungsprogramm – Teilnahmebedingungen","Aufnahmedaten werden geladen …","Projektdaten werden geladen …","Daten zum Eintrag werden geladen …","Vorlagedaten werden geladen …","Benutzerdaten werden geladen …","Daten zum Arbeitsablauf werden geladen …","Indexierung im Internet","Mein nächster Satz","Sie haben leider keine Sätze heruntergeladen und es stehen auch keine ähnlichen Sätze zur Verfügung. Sie können die Indexierung im Internet erneut aufrufen oder auf „Sätze suchen“ klicken, um nach weiteren Sätzen zu suchen.","Es wurden keine Projektanweisungen gefunden.","Es stehen leider keine ähnlichen Sätze zum Herunterladen zur Verfügung. Wählen Sie bitte eine andere Option aus.","Ich stimme nicht zu","OK","OK","Anweisungen zum Projekt","Nutzungsbedingungen nochmals lesen","Ähnlicher Satz","Ähnlichen Satz prüfen","Vielen Dank!","Versuchen Sie es noch einmal","Beim Aktualisieren Ihres Benutzerprofils ist ein Fehler aufgetreten. Klicken Sie auf „OK“, um zur Startseite der Indexierung zurückzukehren.","Fehler beim Speichern der Benutzerakzeptanz","Sätze erstellen","Erstellte Sätze prüfen","Schreibgeschützte Sätze","Satz zurücksenden","Satz einreichen","Zur Indexierung im Internet zurückwechseln","Bearbeiten","Sperrmuster","Daten der Sätze entfernen","Aufnahme sperren","Aufnahme freigeben","Satz teilen","Mit nächstem Satz zusammenlegen","Mit vorherigem Satz zusammenlegen","Ansehen","Anweisungen zum Projekt","Aufnahme ansehen","Nur gesperrte Aufnahmen anzeigen","Sperrsymbole","Satznummern","Satzfarben","Modus","Sperrmodus","Satzmodus","Vorlagemodus","Wiederverarbeitungsmodus","Auswahlmodus"],
    // Included locale file: common_en.json
    "en": ["Close","Don't show instructions again for this project.","The batch submitted successfully. Consider selecting an option below.","The batch was returned successfully. Consider selecting an option below.","Unfortunately, an error occurred when attempting to checkout a similar batch. Please exit to Web Indexing.","A checkout error has occurred. The project has limited the number of batches that can be checked out. Please find another project to batch.","Cancel","FamilySearch indexing requires you to accept the following terms and conditions. Please review each policy and accept before proceeding.","Please Accept Terms and Conditions","I Accept","Exit to indexing overview","FamilySearch Content Submission Agreement","Viewing Shared Batch","You are viewing a shared batch. No information you enter will be saved or submitted.","Viewing Shared Batch as an Admin","You are viewing a batch in read only mode, no information you enter will be saved or submitted.","You are viewing a batch in read only mode, no information you enter will be saved or submitted. Would you like to view it in the Indexing or Review tool?","Open in Review","Open in Indexing","Access Restricted","You are not authorized to open this batch. Please find another batch to work on.","Batch Not Available","The batch you have tried to access is not available. Please find another batch to work on.","Find Batches","FamilySearch Indexing Program Terms and Conditions","Loading Image Data...","Loading Project Data...","Loading Entry Data...","Loading Template Data...","Loading User Data...","Loading Workflow Data...","Web Indexing","My Next Batch","We're sorry but you do not have any batches checked out and there are not any similar batches available for checkout. You may return to Web Indexing or select Find Batches to find additional batches.","No project instructions were found.","We're sorry but there are not any similar batches available for checkout. Please select a different option.","I do not accept","OK","OK","Project Instructions","Review Terms","Similar Batch","Similar Review Batch","Thank You!","Try Again","An error occurred in updating your user profile. Click the 'OK' button to exit to the Indexing home page.","Error Saving User Acceptance","Batching","Batching Review","Batching Read Only","Return Batch","Submit Batch","Return to Web Indexing","Edit","Blocking Pattern","Clear Batching Data","Block Image","Unblock Image","Split Batch","Join Next Batch","Join Previous Batch","View","Project Instructions","View Image","Show Only Blocked Images","Blocked Symbols","Batch Numbers","Batch Colors","Mode","Block Mode","Batch Mode","Pattern Mode","Rebatch Mode","Select Mode"],
    // Included locale file: common_eo.json
    "eo": ["[Çļöšé--- П國カ내]","[Ðöñ'ţ šĥöŵ îñšţŕûçţîöñš åĝåîñ ƒöŕ ţĥîš þŕöĵéçţ.--------------------- П國カ내]","[Ţĥé ƀåţçĥ šûƀɱîţţéð šûççéššƒûļļý. Çöñšîðéŕ šéļéçţîñĝ åñ öþţîöñ ƀéļöŵ.-------------------- П國カ내]","[Ţĥé ƀåţçĥ ŵåš ŕéţûŕñéð šûççéššƒûļļý. Çöñšîðéŕ šéļéçţîñĝ åñ öþţîöñ ƀéļöŵ.-------------- П國カ내]","[Ûñƒöŕţûñåţéļý, åñ éŕŕöŕ öççûŕŕéð ŵĥéñ åţţéɱþţîñĝ ţö çĥéçķöûţ å šîɱîļåŕ ƀåţçĥ. Þļéåšé éẋîţ ţö Ŵéƀ Îñðéẋîñĝ.------------------------ П國カ내]","[Å çĥéçķöûţ éŕŕöŕ ĥåš öççûŕŕéð. Ţĥé þŕöĵéçţ ĥåš ļîɱîţéð ţĥé ñûɱƀéŕ öƒ ƀåţçĥéš ţĥåţ çåñ ƀé çĥéçķéð öûţ. Þļéåšé ƒîñð åñöţĥéŕ þŕöĵéçţ ţö ƀåţçĥ.---------------------------------- П國カ내]","[Çåñçéļ----- П國カ내]","[ƑåɱîļýŠéåŕçĥ îñðéẋîñĝ ŕéǫûîŕéš ýöû ţö åççéþţ ţĥé ƒöļļöŵîñĝ ţéŕɱš åñð çöñðîţîöñš. Þļéåšé ŕéṽîéŵ éåçĥ þöļîçý åñð åççéþţ ƀéƒöŕé þŕöçééðîñĝ.--------------------------------- П國カ내]","[Þļéåšé Åççéþţ Ţéŕɱš åñð Çöñðîţîöñš------------- П國カ내]","[Î Åççéþţ--------- П國カ내]","[Éẋîţ ţö îñðéẋîñĝ öṽéŕṽîéŵ------------- П國カ내]","[ƑåɱîļýŠéåŕçĥ Çöñţéñţ Šûƀɱîššîöñ Åĝŕééɱéñţ----------------- П國カ내]","[Ṽîéŵîñĝ Šĥåŕéð Ɓåţçĥ------------- П國カ내]","[Ýöû åŕé ṽîéŵîñĝ å šĥåŕéð ƀåţçĥ. Ñö îñƒöŕɱåţîöñ ýöû éñţéŕ ŵîļļ ƀé šåṽéð öŕ šûƀɱîţţéð.------------------ П國カ내]","[Ṽîéŵîñĝ Šĥåŕéð Ɓåţçĥ åš åñ Åðɱîñ------------ П國カ내]","[Ýöû åŕé ṽîéŵîñĝ å ƀåţçĥ îñ ŕéåð öñļý ɱöðé, ñö îñƒöŕɱåţîöñ ýöû éñţéŕ ŵîļļ ƀé šåṽéð öŕ šûƀɱîţţéð.--------------------- П國カ내]","[Ýöû åŕé ṽîéŵîñĝ å ƀåţçĥ îñ ŕéåð öñļý ɱöðé, ñö îñƒöŕɱåţîöñ ýöû éñţéŕ ŵîļļ ƀé šåṽéð öŕ šûƀɱîţţéð. Ŵöûļð ýöû ļîķé ţö ṽîéŵ îţ îñ ţĥé Îñðéẋîñĝ öŕ Ŕéṽîéŵ ţööļ?-------------------------------------- П國カ내]","[Öþéñ îñ Ŕéṽîéŵ------- П國カ내]","[Öþéñ îñ Îñðéẋîñĝ--------- П國カ내]","[Åççéšš Ŕéšţŕîçţéð---------- П國カ내]","[Ýöû åŕé ñöţ åûţĥöŕîžéð ţö öþéñ ţĥîš ƀåţçĥ. Þļéåšé ƒîñð åñöţĥéŕ ƀåţçĥ ţö ŵöŕķ öñ.----------------- П國カ내]","[Ɓåţçĥ Ñöţ Åṽåîļåƀļé------------ П國カ내]","[Ţĥé ƀåţçĥ ýöû ĥåṽé ţŕîéð ţö åççéšš îš ñöţ åṽåîļåƀļé. Þļéåšé ƒîñð åñöţĥéŕ ƀåţçĥ ţö ŵöŕķ öñ.-------------------- П國カ내]","[Ƒîñð Ɓåţçĥéš----- П國カ내]","[ƑåɱîļýŠéåŕçĥ Îñðéẋîñĝ Þŕöĝŕåɱ Ţéŕɱš åñð Çöñðîţîöñš----------------------- П國カ내]","[Ļöåðîñĝ Îɱåĝé Ðåţå...--------- П國カ내]","[Ļöåðîñĝ Þŕöĵéçţ Ðåţå...----------- П國カ내]","[Ļöåðîñĝ Éñţŕý Ðåţå...--------- П國カ내]","[Ļöåðîñĝ Ţéɱþļåţé Ðåţå...------------ П國カ내]","[Ļöåðîñĝ Ûšéŕ Ðåţå...------------- П國カ내]","[Ļöåðîñĝ Ŵöŕķƒļöŵ Ðåţå...------------ П國カ내]","[Ŵéƀ Îñðéẋîñĝ----- П國カ내]","[Ṁý Ñéẋţ Ɓåţçĥ------ П國カ내]","[Ŵé'ŕé šöŕŕý ƀûţ ýöû ðö ñöţ ĥåṽé åñý ƀåţçĥéš çĥéçķéð öûţ åñð ţĥéŕé åŕé ñöţ åñý šîɱîļåŕ ƀåţçĥéš åṽåîļåƀļé ƒöŕ çĥéçķöûţ. Ýöû ɱåý ŕéţûŕñ ţö Ŵéƀ Îñðéẋîñĝ öŕ šéļéçţ Ƒîñð Ɓåţçĥéš ţö ƒîñð åððîţîöñåļ ƀåţçĥéš.---------------------------------------------------- П國カ내]","[Ñö þŕöĵéçţ îñšţŕûçţîöñš ŵéŕé ƒöûñð.-------------- П國カ내]","[Ŵé'ŕé šöŕŕý ƀûţ ţĥéŕé åŕé ñöţ åñý šîɱîļåŕ ƀåţçĥéš åṽåîļåƀļé ƒöŕ çĥéçķöûţ. Þļéåšé šéļéçţ å ðîƒƒéŕéñţ öþţîöñ.------------------------- П國カ내]","[Î ðö ñöţ åççéþţ-------- П國カ내]","[ÖĶ П]","[ÖĶ П]","[Þŕöĵéçţ Îñšţŕûçţîöñš------------- П國カ내]","[Ŕéṽîéŵ Ţéŕɱš----- П國カ내]","[Šîɱîļåŕ Ɓåţçĥ------ П國カ내]","[Šîɱîļåŕ Ŕéṽîéŵ Ɓåţçĥ------------- П國カ내]","[Ţĥåñķ Ýöû!------------- П國カ내]","[Ţŕý Åĝåîñ----------- П國カ내]","[Åñ éŕŕöŕ öççûŕŕéð îñ ûþðåţîñĝ ýöûŕ ûšéŕ þŕöƒîļé. Çļîçķ ţĥé 'ÖĶ' ƀûţţöñ ţö éẋîţ ţö ţĥé Îñðéẋîñĝ ĥöɱé þåĝé.------------------------ П國カ내]","[Éŕŕöŕ Šåṽîñĝ Ûšéŕ Åççéþţåñçé--------------- П國カ내]","[Ɓåţçĥîñĝ--------- П國カ내]","[Ɓåţçĥîñĝ Ŕéṽîéŵ-------- П國カ내]","[Ɓåţçĥîñĝ Ŕéåð Öñļý----------- П國カ내]","[Ŕéţûŕñ Ɓåţçĥ----- П國カ내]","[Šûƀɱîţ Ɓåţçĥ----- П國カ내]","[Ŕéţûŕñ ţö Ŵéƀ Îñðéẋîñĝ---------- П國カ내]","[Éðîţ- П國カ내]","[Ɓļöçķîñĝ Þåţţéŕñ--------- П國カ내]","[Çļéåŕ Ɓåţçĥîñĝ Ðåţå------------ П國カ내]","[Ɓļöçķ Îɱåĝé---- П國カ내]","[Ûñƀļöçķ Îɱåĝé------ П國カ내]","[Šþļîţ Ɓåţçĥ---- П國カ내]","[Ĵöîñ Ñéẋţ Ɓåţçĥ-------- П國カ내]","[Ĵöîñ Þŕéṽîöûš Ɓåţçĥ------------ П國カ내]","[Ṽîéŵ- П國カ내]","[Þŕöĵéçţ Îñšţŕûçţîöñš------------- П國カ내]","[Ṽîéŵ Îɱåĝé------------- П國カ내]","[Šĥöŵ Öñļý Ɓļöçķéð Îɱåĝéš------------ П國カ내]","[Ɓļöçķéð Šýɱƀöļš-------- П國カ내]","[Ɓåţçĥ Ñûɱƀéŕš------ П國カ내]","[Ɓåţçĥ Çöļöŕš----- П國カ내]","[Ṁöðé- П國カ내]","[Ɓļöçķ Ṁöðé------------- П國カ내]","[Ɓåţçĥ Ṁöðé------------- П國カ내]","[Þåţţéŕñ Ṁöðé----- П國カ내]","[Ŕéƀåţçĥ Ṁöðé----- П國カ내]","[Šéļéçţ Ṁöðé---- П國カ내]"],
    // Included locale file: common_es.json
    "es": ["Cerrar","No mostrar las instrucciones para este proyecto otra vez.","El lote se ha enviado correctamente Considera seleccionar una de las opciones a continuación.","Se devolvió el lote correctamente. Considera seleccionar una de las siguientes opciones.","Desafortunadamente, ocurrió un error cuando se trató de reservar un lote similar. Por favor, regresa a Indexación en línea.","Se produjo un error al reservar el lote. Este proyecto tiene un número limitado de lotes que puedes reservar. Por favor, encuentra otro proyecto para organizar en lotes.","Cancelar","FamilySearch Indexing requiere que aceptes los siguientes términos y condiciones. Por favor, revisa cada norma y acéptalas antes de proceder.","Por favor, acepta los términos y condiciones","Acepto","Salir a la reseña de indexación","Contrato de envío de contenido de FamilySearch","Ver lote compartido","Estás viendo un lote compartido. No se grabará ni se enviará ninguna información que ingreses.","Ver lote compartido como administrador","Estás viendo un lote en modo solo para lectura, ninguna información que ingreses se guardará o enviará.","Estás viendo un lote en modo solo para lectura, ninguna información que ingreses se guardará o enviará. ¿Deseas verlo en la herramienta de Indexación o Revisión?","Abierto en Revisar","Abierto en Indexación","Acceso restringido","No tienes autorización para abrir este lote. Por favor, encuentra otro lote para que puedas trabajar en él.","El lote no está disponible","El lote al que has tratado de acceder no está disponible. Por favor, encuentra otro lote para que puedas trabajar en él.","Encontrar lotes","Términos y condiciones del programa FamilySearch Indexing.","Cargando los datos de la imagen…","Cargando los datos del proyecto…","Cargando los datos del registro…","Cargando los datos de la plantilla…","Cargando los datos del usuario…","Cargando los datos del flujo de trabajo…","Indexación en línea","Mi próximo lote","Lo sentimos, pero no tienes ningún lote reservado y no hay lotes similares disponibles para reservar. Puedes regresar a la Indexación en línea o seleccionar Encontrar lotes para buscar lotes adicionales.","No se encontraron instrucciones del proyecto.","Lo sentimos, pero no hay lotes similares disponibles para reservar. Por favor, selecciona una opción diferente.","No acepto","Aceptar","Aceptar","Instrucciones del proyecto","Revisar los términos y condiciones","Lote similar","Lote similar para revisar","¡Muchas gracias!","Inténtalo de nuevo","Se produjo un error al actualizar tu perfil de usuario. Haz clic en el botón ‘Aceptar’ para salir a la página de inicio de Indexación.","Se produjo un error al guardar la aceptación del usuario","Organización de lotes","Revisión de la organización de lotes","Organización de lotes en modo Solo de lectura","Devolver lote","Enviar lote","Regresar a la Indexación en línea","Editar","Patrón de bloqueo","Borrar datos de lotes","Bloquear imagen","Desbloquear imagen","Dividir lote","Combinar con lote siguiente","Combinar con lote anterior","Ver","Instrucciones del proyecto","Ver imagen","Mostrar solo imágenes bloqueadas","Símbolos bloqueados","Números de lote","Colores del lote","Modo","Modo de bloqueo","Modo de lote","Modo de patrón","Modo de reorganización de lote","Selecciona el modo"],
    // Included locale file: common_fr.json
    "fr": ["Fermer","Ne plus afficher les instructions de ce projet.","Transmission du lot réussie. Choisissez  parmi l’une des options suivantes.","Le lot a été renvoyé avec succès. Choisissez parmi l’une des options suivantes.","Malheureusement, une erreur s’est produite en essayant de sortir un lot similaire. Quitter pour retourner au progiciel d’indexation en ligne.","Une erreur de sortie du lot s’est produite. Le projet limite le nombre de lots qui peuvent être sortis. Veuillez trouver un autre lot sur lequel travailler.","Annuler","L’indexation de FamilySearch requiert que vous acceptiez les termes et conditions suivants. Veuillez lire toutes les directives et les accepter avant de continuer.","Veuillez accepter les termes et conditions","Je relève le défi","Retour à l’aperçu de l’indexation","Accord relatif au Contenu des Données Personnelles transmises à FamilySearch","Affichage de lot partagé","Vous affichez un lot partagé. Aucun des renseignements que vous saisissez ne sera enregistré ou envoyé.","Affichage de lot partagé en tant qu’administrateur","Le lot est ouvert en mode « Lecture seule », aucun renseignement saisi ne sera enregistré ou envoyé.","Le lot est ouvert en mode « Lecture seule », aucun renseignement saisi ne sera enregistré ou envoyé. Souhaitez-vous le consulter via la rubrique d’indexation ou de vérification ?","Ouvrir le lot dans la rubrique de vérification","Ouvrir le lot dans la rubrique d’indexation","Accès limité","Vous n’êtes pas autorisé à ouvrir ce lot. Veuillez trouver un autre lot sur lequel travailler.","Lot non disponible","Le lot auquel vous essayez d’accéder n’est pas disponible. Veuillez trouver un autre lot sur lequel travailler.","Trouver des lots","Termes et conditions du programme d’indexation de FamilySearch","Chargement des données de l’image en cours…","Chargement des données du projet en cours…","Chargement en cours des données du document…","Chargement des données du modèle en cours…","Chargement des données de l’utilisateur en cours…","Chargement du flux de travail en cours…","Progiciel d’indexation en ligne","Mon lot suivant","Désolé, vous n’avez aucun lot réservé, et aucun lot similaire à vérifier n’est disponible. Vous pouvez revenir au progiciel d’indexation en ligne ou sélectionner « Trouver des lots » pour trouver d’autres lots.","Aucune instruction trouvée pour ce projet.","Désolé, il n'y a aucun lot similaire à vérifier de disponible. Veuillez sélectionner une option différente.","Je n’accepte pas","OK","OK","Instructions du projet","Consulter les termes","Lot similaire","Vérification de lot similaire","Merci !","Réessayez","Une erreur s’est produite pendant la sauvegarde de votre profil d’utilisateur. Cliquez sur le bouton « Ok » pour revenir à la page d’accueil de l’indexation.","Erreur d’enregistrement de l’acceptation des utilisateurs","Traitement par lot","Vérification du traitement par lot","Traitement par lot en lecture seule","Renvoyer le lot","Transmettre le lot","Retourner au progiciel d’indexation en ligne","Modifier","Modèle de blocage","Suppression de données de traitement par lot","Bloquer l’image","Débloquer l’image","Fractionner le lot","Joindre le lot suivant","Joindre le lot précédent","Afficher","Instructions du projet","Afficher l’image","N’afficher que les images bloquées","Symboles bloqués","Numéros de lots","Couleurs de lots","Mode","Mode de blocage","Mode de traitement par lot","Mode Modèle","Mode de retraitement par lot","Sélectionner le mode"],
    // Included locale file: common_it.json
    "it": ["Chiudi","Non mostrare più le istruzioni per questo progetto","Il batch è stato trasmesso con successo. Scegli una delle opzioni qui sotto.","Il batch è stato restituito con successo. Scegli una delle opzioni sottostanti.","Purtroppo si è verificato un errore nello scaricamento di un batch simile. Esci da Indicizzazione sul web.","Si è verificato un errore nello scaricamento. Il progetto ha limitato il numero di batch che si possono scaricare. Trova un altro progetto da cui scaricare batch.","Annulla","L’indicizzazione di FamilySearch richiede l’accettazione dei seguenti termini e condizioni. Leggi ciascuna direttiva e accetta prima di procedere.","Accetta i termini e le condizioni","Accetto","Esci e vai al quadro generale dell’indicizzazione","Accordo per l’invio dei dati a FamilySearch","Visualizzato batch condiviso","Stai visualizzando un batch condiviso. Nessuna informazione inserita sarà salvata o inviata.","Batch condiviso visualizzato in modalità Amministratore","Stai visualizzando il batch in modalità di sola lettura. Nessuna informazione inserita sarà salvata o inviata.","Stai visualizzando il batch in modalità di sola lettura. Nessuna informazione inserita sarà salvata o inviata. Desideri visualizzarlo nello strumento per l’indicizzazione o in quello per la revisione?","Apri per revisionare","Apri per indicizzare","Accesso limitato","Non sei autorizzato ad aprire questo batch. Trova un altro batch a cui lavorare.","Batch non disponibile","Il batch che hai richiesto non è disponibile. Trova un altro batch a cui lavorare.","Trova i batch","Termini e condizioni del programma di indicizzazione di FamilySearch","Caricamento dati immagine…","Caricamento dati progetto…","Caricamento dati del record in corso…","Caricamento dati modello…","Caricamento dati utente…","Caricamento dati del flusso di lavoro…","Indicizzazione sul web","Il mio prossimo batch","Siamo spiacenti, ma non hai nessun batch scaricato e non ci sono batch simili da scaricare. Puoi ritornare a Indicizzazione sul web o selezionare Trova batch per trovare altri batch.","Non sono state trovate istruzioni sul progetto.","Siamo spiacenti, ma non ci sono batch simili da scaricare. Seleziona un’opzione differente.","Non accetto","OK","OK","Istruzioni sul progetto","Leggi i termini","Batch simile","Batch simile da revisionare","Grazie!","Riprova","Si è verificato un errore durante l’aggiornamento del tuo profilo utente. Clicca il pulsante ‘OK’ per uscire e andare alla pagina iniziale dell’indicizzazione.","Errore nel salvataggio dell’accettazione dell’utente","Suddivisione in batch","Revisione della suddivisione in batch","Suddivisione in batch di sola lettura","Restituisci batch","Trasmetti batch","Ritorna a Indicizzazione sul web","Modifica","Schema di blocco","Cancella dati della suddivisione in batch","Blocca immagine","Sblocca immagine","Dividi batch","Unisci al batch successivo","Unisci al batch precedente","Visualizza","Istruzioni sul progetto","Visualizza immagine","Mostra solo immagini bloccate","Simboli immagine bloccata","Numeri del batch","Colori del batch","Modalità","Modalità Blocco","Modalità Suddivisione","Modalità Schema","Modalità Rielabora suddivisione","Modalità Selezione"],
    // Included locale file: common_ja.json
    "ja": ["閉じる","今後このプロジェクトの指示を表示しない。","無事にバッチを提出しました。 以下のオプションを選んでください。","無事にバッチを返却しました。以下のオプションを選んでください。","残念ながら，類似したバッチのチェックアウト中にエラーが発生しました。「ウェブ索引作成」に戻ってください。","チェックアウトのエラーが発生しました。 このプロジェクトは限られた数のバッチしかチェックアウトできません。 他のプロジェクトを見つけてバッチ設定してください。","キャンセル","ファミリーサーチ・索引作成をご利用いただくには，使用条件に従うことを承諾していただく必要があります。 続ける前にそれぞれの方針を確認して承諾してください。","使用条件を承諾してください","承諾します","索引作成の概要に戻る","ファミリーサーチコンテンツ投稿規約","共有されたバッチの表示中","共有されたバッチを表示しています。 あなたが入力したどの情報も，保存または提出されることはありません。","管理者として共有されたバッチを表示しています","読み取り専用モードでバッチを表示しています。あなたが入力したどの情報も，保存または提出されることはありません。","読み取り専用モードでバッチを表示しています。あなたが入力したどの情報も，保存または提出されることはありません。バッチを「索引作成」ツールで表示しますか，それとも「見直し」ツールで表示しますか。","見直しツールで開く","索引作成ツールで開く","アクセスの制限","あなたにはこのバッチを開く権限がありません。 他のバッチを見つけて作業してください。","バッチは利用できません","アクセスしようとしたバッチは利用できません。 他のバッチを見つけて作業してください。","バッチを見つける","ファミリーサーチ索引作成プログラムの使用条件","画像データをロード中……","プロジェクトデータをロード中……","エントリデータをロード中……","テンプレートデータをロード中……","ユーザーデータをロード中……","ワークフローデータをロード中……","ウェブ索引作成","次のバッチ","申し訳ありませんが，チェックアウトしたバッチは何もありません。また，チェックアウトできる類似したバッチもありません。「ウェブ索引作成」に戻るか，「バッチを見つける」を選んで別のバッチを見つけてください。","プロジェクトの指示が見つかりません。","申し訳ありませんが，チェックアウトできる類似したバッチはありません。 違うオプションを選択してください。","承諾しません","OK","OK","プロジェクトの指示","使用条件を確認する","類似したバッチ","類似した見直しが必要なバッチ","ありがとうございました!","もう一度試してみてください","ユーザープロフィールの更新中にエラーが発生しました。 「OK」ボタンをクリックすると，索引作成のホームページに戻ります。","ユーザー承諾の保存エラー","バッチ設定","バッチ設定レビュー","バッチ設定，読み取り専用","バッチの返却","バッチの提出","「ウェブ索引作成」に戻る","編集","ブロックパターン","バッチデータをクリアする","画像をブロックする","画像のブロック解除","バッチの分割","次のバッチと連結","前のバッチと連結","表示","プロジェクトの指示","画像の表示","ブロックされた画像のみを表示","ブロックされたシンボル","バッチ番号","バッチの色","モード","ブロックモード","バッチモード","パターンモード","再バッチモード","選択モード"],
    // Included locale file: common_nl.json
    "nl": ["Sluiten","Instructies voor dit project niet meer weergeven.","De batch is ingediend. U kunt hieronder een optie selecteren.","De batch is succesvol teruggestuurd. U kunt hieronder een optie selecteren.","Er is helaas een fout opgetreden bij het binnenhalen van een soortgelijke batch. Gelieve terug naar Webindexering te gaan.","Er is bij het binnenhalen een fout opgetreden. Voor dit project is er een limiet gesteld aan het aantal binnen te halen batches. Zoek alstublieft een andere batch waaraan u kunt werken.","Annuleren","U dient voor het gebruik van het FamilySearch-indexeringsprogramma de volgende voorwaarden te accepteren. Gelieve het beleid door te lezen en te accepteren voordat u verdergaat.","Gelieve de voorwaarden te accepteren","Ik ga akkoord","Ga terug naar het indexeringsoverzicht","Overeenkomst indienen inhoud FamilySearch","Overlegbatch bekijken","U bekijkt een overlegbatch. Er worden geen gegevens opgeslagen of ingediend.","Overlegbatch als beheerder bekijken","U bekijkt een batch in de modus Alleen-lezen. Er worden geen gegevens opgeslagen of ingediend.","U bekijkt een batch in de modus Alleen-lezen. Er worden geen gegevens opgeslagen of ingediend. Wilt u hem in de indexeringstool of de controletool bekijken?","In Controle openen","In Indexering openen","Toegang beperkt","U bent niet gemachtigd om deze batch te openen. Zoek alstublieft een andere batch waaraan u kunt werken.","Batch niet beschikbaar","De gewenste batch is niet beschikbaar. Zoek alstublieft een andere batch waaraan u kunt werken.","Batches zoeken","Voorwaarden FamilySearch-indexeringsprogramma","Afbeeldingsgegevens aan het laden…","Projectgegevens aan het laden…","Vermeldingsgegevens aan het laden…","Sjabloongegevens aan het laden…","Gebruikersgegevens aan het laden…","Workflowgegevens aan het laden…","Webindexering","Mijn volgende batch","Het spijt ons, maar u hebt geen batches binnengehaald en er zijn geen soortgelijke batches om binnen te halen. U kunt naar Webindexering terugkeren of met Batches zoeken meer batches opsporen.","Er zijn geen projectinstructies gevonden.","Het spijt ons, maar er zijn geen soortgelijke batches om binnen te halen. Gelieve een andere optie te selecteren.","Ik ga niet akkoord","OK","OK","Projectinstructies","Voorwaarden doorlezen","Soortgelijke batch","Soortgelijke controlebatch","Bedankt!","Opnieuw proberen","Er is een fout opgetreden bij het bijwerken van uw gebruikersprofiel. Klik op OK om naar de homepage van de indexeringswebsite te gaan.","Fout bij opslaan van de toestemming van de gebruiker","Batchen","Controle batchen","Batchen — alleen lezen","Batch terugsturen","Batch indienen","Terug naar Webindexering","Bewerken","Blokkeerpatroon","Batchgegevens wissen","Afbeelding blokkeren","Blokkering afbeelding opheffen","Batch splitsen","Bij volgende batch voegen","Bij vorige batch voegen","Bekijken","Projectinstructies","Afbeelding bekijken","Alleen geblokkeerde afbeeldingen tonen","Geblokkeerde symbolen","Batchnummers","Batchkleuren","Modus","Blokkeermodus","Batchmodus","Patroonmodus","Herbatchenmodus","Selecteermodus"],
    // Included locale file: common_pl.json
    "pl": ["Zamknij","Nie pokazuj ponownie instrukcji do tego projektu.","Plik odesłano pomyślnie. Rozważ wybranie opcji poniżej.","Plik został pomyślnie zwrócony. Rozważ wybranie opcji poniżej.","Niestety, wystąpił błąd przy próbie otwarcia podobnego pliku. Przejdź do Indeksowania on-line.","Wystąpił błąd podczas pobierania. Ten projekt ma ograniczenie liczby plików, które można pobrać. Wybierz inny projekt, aby pobrać pliki.","Anuluj","Indeksowanie dla FamilySearch wymaga, abyś zaakceptował następujące poniższe warunki użytkowania. Przejrzyj wszystkie zasady i zaakceptuj je, zanim przejdziesz dalej.","Prosimy o zaakceptowanie warunków użytkowania","Akceptuję","Przejdź do przeglądu indeksowania","Umowa na zamieszczanie treści na stronie FamilySearch","Przejrzyj udostępniony plik","Oglądasz udostępniony plik. Żadne wprowadzone przez ciebie informacje nie będą zapisane ani przesłane.","Oglądanie udostępnionego pliku jako administrator","Oglądasz plik w trybie wyłącznie do odczytu. Żadne wprowadzone przez ciebie informacje nie zostaną zapisane ani przesłane.","Oglądasz plik w trybie wyłącznie do odczytu. Żadne wprowadzone przez ciebie informacje nie zostaną zapisane ani przesłane. Czy chcesz obejrzeć ten plik za pomocą narzędzia do indeksowania lub przeglądu?","Otwórz w trybie przeglądu","Otwórz w trybie indeksowania","Ograniczony dostęp","Nie masz uprawnień do otworzenia tego pliku. Znajdź inny plik, nad którym będziesz pracować.","Plik jest niedostępny","Plik, do którego próbujesz uzyskać dostęp, jest niedostępny. Znajdź inny plik, nad którym będziesz pracować.","Znajdź pliki","Warunki użytkowania programu do indeksowania FamilySearch","Ładowanie danych zdjęcia…","Ładowanie danych projektu…","Ładowanie danych wpisu…","Ładowanie danych szablonu…","Ładowanie danych użytkownika…","Ładowanie danych przepływu pracy…","Indeksowanie on-line","Mój następny plik","Przykro nam, ale nie masz żadnych plików do otwarcia ani nie ma żadnych podobnych plików. Możesz powrócić do Indeksowania on-line lub wybrać opcję Znajdź pliki, aby znaleźć dodatkowe pliki.","Nie znaleziono instrukcji do projektu.","Przykro nam, ale nie ma podobnych plików do otwarcia. Wybierz inną opcję.","Nie akceptuję","OK","OK","Instrukcje do projektu","Przejrzyj warunki","Podobny plik","Podobny plik do przeglądu ","Dziękujemy!","Spróbuj jeszcze raz","Wystąpił błąd podczas aktualizacji twojego profilu użytkownika. Kliknij przycisk ‘OK’, aby przejść do strony głównej programu indeksowania.","Błąd zapisywania akceptacji użytkownika","Podział na pliki","Przegląd podziału na pliki","Podział na pliki tylko do odczytu","Zwróć plik","Odeślij plik","Wróć do Indeksowania on-line","Edytuj","Blokowanie wzoru","Wyczyść dane podziału na pliki","Zablokuj zdjęcie","Odblokuj zdjęcie","Podziel plik","Połącz następny plik","Połącz poprzedni plik","Wyświetl","Instrukcje do projektu","Wyświetl zdjęcie","Pokaż tylko zablokowane zdjęcia","Symbole zablokowane","Numery pliku","Kolory pliku","Tryb","Zablokuj tryb","Tryb pliku","Tryb wzoru","Tryb ponownego podziału na pliki","Wybierz tryb"],
    // Included locale file: common_pt.json
    "pt": ["Fechar","Não mostrar as instruções deste projeto novamente.","O lote foi enviado com sucesso. Considere uma das opções abaixo.","O lote foi devolvido com sucesso. Considere uma das opções abaixo.","Infelizmente, ocorreu um erro ao tentar retirar um lote semelhante. Vá para a Indexação via Web.","Ocorreu um erro durante a retirada de lote. O projeto tem um limite de lotes que podem ser retirados.  Procure outro projeto para organizar em lotes.","Cancelar","A Indexação do FamilySearch requer que você aceite os seguintes termos e condições:  Revise e aceite as normas antes de continuar.","Aceite os Termos e as Condições","Aceito","Ir para a visão geral de Indexação.","Contrato de Envio de Conteúdo do FamilySearch","Visualização: Lote Compartilhado","Você está vendo um lote compartilhado. Nenhuma informação que você digitar será salva ou enviada. ","Visualizando o Lote Compartilhado como um Administrador.","Você está vendo um lote no modo “Somente para Leitura”, nenhuma informação que você digitar será salva ou enviada.","Você está vendo um lote no modo “Somente para Leitura”, nenhuma informação que você digitar será salva ou enviada. Você gostaria de vê-lo na ferramenta de Indexação ou Revisão?","Abrir para Revisão","Abrir para Indexação","Acesso Restrito.","Você não está autorizado a abrir este lote. Procure outro lote em que você gostaria de trabalhar.","Lote Indisponível","O lote que você tentou acessar não está disponível. Procure outro lote em que você gostaria de trabalhar.","Procurar Lotes","Termos e Condições do Programa de Indexação do FamilySearch","Carregando os dados da imagem ...","Carregando os dados do projeto ...","Carregando os dados do registro (…)","Carregando os dados do modelo ...","Carregando os dados do usuário ...","Carregando os dados do fluxo de trabalho...","Indexação via Web","Meu Próximo Lote","Você não tem nenhum lote retirado e não há nenhum lote similar disponível para retirada. Você pode retornar à Indexação via Web ou selecionar “Procurar Lotes” para procurar outros lotes.","As instruções do projeto não foram encontradas.","Desculpe, mas não há nenhum lote semelhante disponível para retirada. Selecione uma opção diferente.","Não Aceito","OK","OK","Instruções do Projeto","Revisar os Termos","Lote Semelhante","Lote Semelhante de Revisão","Obrigado!","Tente novamente","Ocorreu um erro durante a atualização do seu perfil de usuário. Clique no botão OK para ir para a página principal de Indexação.","Ocorreu um erro ao salvar a “aceitação do usuário”.","Organização de Lotes","Revisão de Organização de Lotes","Organização de Lotes: Somente Leitura","Devolver Lote","Enviar o Lote","Voltar à Indexação via Web","Alterar","Sequência do Bloqueio","Apagar dados do Agrupamento","Bloquear a Imagem ","Desbloquear a Imagem ","Dividir o Lote","Juntar ao Próximo Lote","Juntar ao Lote Anterior","Ver:","Instruções do Projeto","Ver Imagem","Mostrar somente Imagens Bloqueadas","Símbolos Bloqueados","Números dos Lotes","Cores do Lote","Modo","Modo de Bloqueio","Modo do Lote","Modo de Sequência","Modo de Reloteamento","Selecionar o Modo"],
    // Included locale file: common_ru.json
    "ru": ["Закрыть","Больше не показывать инструкции для этого проекта.","Партия отправлена успешно. Вы можете выбрать одну из приведенных ниже опций.","Партия успешно возвращена. Вы можете выбрать одну из приведенных ниже опций.","К сожалению, при загрузке подобной партии произошла ошибка. Пожалуйста, вернитесь в раздел Онлайн-индексирование.","Произошла ошибка при получении партии. В этом проекте ограничено число партий, которые можно получить. Пожалуйста, найдите другой проект, чтобы загрузить партию.","Отменить","Для того, чтобы участвовать в индексировании FamilySearch, вам необходимо принять следующие условия и положения. Пожалуйста, перед тем как продолжить, ознакомьтесь со всеми правилами и подтвердите согласие принять их.","Пожалуйста, укажите, что вы согласны с Положениями и Условиями","Я согласен(а)","Выход в Краткий обзор индексирования","Соглашение о предоставлении материала FamilySearch","Просмотр партии для совместной работы","Вы просматриваете партию для совместной работы. Вводимая вами информация не может быть сохранена или отправлена.","Просмотр партии для совместной работы в роли администратора","Вы просматриваете партию, доступную только для чтения. Любые вводимые вами данные не будут сохранены или отправлены.","Вы просматриваете партию, доступную только для чтения. Любые вводимые вами данные не будут сохранены или отправлены. Вы хотите просмотреть эти данные, используя инструмент для индексирования или для проверки? ","Открыть для проверки","Открыть для индексирования","Доступ ограничен","У вас нет прав открыть эту партию. Пожалуйста, выберите для работы другую партию.","Партия недоступна","Данная партия, к которой вы пытаетесь получить доступ, недоступна. Пожалуйста, выберите для работы другую партию.","Найти партии","Положения и условия программы индексирования FamilySearch","Загрузка данных снимка...","Загрузка данных проекта...","Загрузка данных записи...","Загрузка данных шаблона...","Загрузка данных пользователя...","Загрузка данных потока работ...","Онлайн-индексирование","Моя следующая партия","К сожалению, у вас нет загруженных партий, и подобные партии тоже недоступны. Вы можете вернуться в раздел Онлайн-индексирование или выбрать опцию «Найти партии» для поиска дополнительных партий.","Не удалось найти инструкции к проекту.","К сожалению, подобных партий для загрузки нет. Пожалуйста, выберите другую опцию.","Я не согласен(а)","OK","OK","Инструкции к проекту","Просмотреть условия","Подобная партия","Подобная партия для проверки","Спасибо!","Попробуйте снова","При обновлении вашего профиля пользователя произошла ошибка. Нажмите кнопку OK, чтобы вернуться на главную страницу Индексирования.","Ошибка при сохранении принятия пользователем","Группировка","Проверка группировки","Группировка только для чтения","Вернуть партию","Отправить партию","Вернуться в раздел Онлайн-индексирование","Редактировать","Тип блокировки","Отменить группировку","Блокировать снимок","Разблокировать снимок","Разделить партию на части","Объединить со следующей партией","Объединить с предыдущей партией","Просмотр","Инструкции к проекту","Просмотреть снимок","Показать только блокированные снимки","Символы блокирования","Номера партии","Цвета партии","Режим","Режим блокирования","Режим партии","Режим образца","Режим перегруппировки","Выбрать режим"],
    // Included locale file: common_sv.json
    "sv": ["Stäng","Visa inte instruktionerna igen för det här projektet.","Bunten har skickats. Du kan välja ett alternativ nedan.","Bunten returnerades. Du kan välja ett alternativ nedan.","Ett fel uppstod vid utcheckningen av en liknande bunt. Gå till Indexering via nätet.","Ett utcheckningsfel har uppstått. Projektet har ett begränsat antal buntar som kan checkas ut.  Välj ett annat projekt att arbeta med.","Avbryt","FamilySearch Indexering kräver att du godkänner följande villkor. Gå igenom varje policy och samtyck till dem innan du fortsätter.","Vänligen samtyck till villkor","Jag samtycker","Gå tillbaka till översiktssidan","FamilySearch – Avtal om inskickning av material","Visar delad bunt","Du tittar på en delad bunt. Ingen information du anger sparas eller skickas in.","Delad bunt har öppnats i admin-läge","Du har öppnat en bunt i skrivskyddat läge, ingen information du anger sparas eller skickas in.","Du har öppnat en bunt i skrivskyddat läge, ingen information du anger sparas eller skickas in. Vill du öppna den i indexerings- eller granskningsverktyget?","Öppna i granskningsläge","Öppna i indexeringsläge","Begränsad tillgång","Du har inte behörighet att öppna den här bunten. Välj en annan bunt att arbeta med.","Bunten är inte tillgänglig","Bunten som du försökte nå är inte tillgänglig. Välj en annan bunt att arbeta med.","Hitta buntar","FamilySearch indexeringsprogram – Villkor","Läser in bilduppgifter …","Läser in projektuppgifter …","Läser in inmatningsdata ...","Läser in malluppgifter …","Läser in användaruppgifter …","Läser in arbetsflödesuppgifter …","Indexering via nätet","Min nästa bunt","Du har tyvärr inga utcheckade buntar och det finns inga liknande buntar för utcheckning. Du kan gå tillbaka till indexeringen via nätet eller trycka på Hitta buntar för att hitta fler buntar.","Inga projektinstruktioner hittades.","Det finns tyvärr inga liknande buntar för utcheckning. Välj ett annat alternativ.","Jag samtycker inte","Okej","Okej","Projektinstruktioner","Gå igenom villkor","Liknande bunt","Liknande granskningsbunt","Tack!","Försök igen","Ett fel uppstod när din användarprofil skulle uppdateras. Klicka på knappen OK för att komma tillbaka till indexeringens startsida.","Det gick inte att spara användarens godkännande","Buntning","Granskning av buntning","Buntning - Skrivskyddad","Returnera bunt","Skicka bunt","Gå tillbaka till Indexering via nätet","Ändra","Blockeringsmönster","Rensa buntdata","Blockera bild","Avblockera bild","Dela upp bunt","Koppla till nästa bunt","Koppla till föregående bunt","Visa","Projektinstruktioner","Visa bild","Visa bara blockerade bilder","Blockerade symboler","Buntnummer","Buntfärger","Läge","Blockeringsläge","Buntläge","Mönsterläge","Ombuntningsläge","Välj läge"],
  };
  var validLocales = ["de","en","eo","es","fr","it","ja","ke","nl","pl","pt","ru","sv","zz"];

  function getLang(locales) {
    var locale, language, i, len = langKeys.length, lang = {};
    locales = (typeof locales === 'string' ? [locales] : locales);
    for (i = 0; i < locales.length; i++) {
      language = locales[i];
      if (validLocales.indexOf(language) !== -1) {
        locale = language;
        break;
      } else {
        //Check if the first two characters are a valid locale
        language = locales[i].split('-')[0];
        if (validLocales.indexOf(language) !== -1) {
          locale = language;
          break;
        }
      }
    }
    locale = locale || 'en';
    var temp;
    switch (locale) {
      case 'ke':
      case 'zz':
        for(i = 0; i < len; i++) {
          temp = (locale === 'ke' ? '[' + langKeys[i] + ']' : '[idxCommon.' + langKeys[i] + ']');
          lang[langKeys[i]] = temp;
        }
        break;

      default:
        for(i = 0; i < len; i++) {
          lang[langKeys[i]] = langs[locale][i];
        }
        break;
    }
    return lang;
  }

  var lang = getLang(FS.simpleLocale() || 'en');

  var templateList = {
    // Included template file: ../templates/idxTermsAndConditionsModal.html
    "idxTermsAndConditionsModal": '<idx-terms-and-conditions-modal-body> <p ng-if="showAcceptanceAlert" class="alert alert-warning"> {accept-terms-and-conditions-body} </p> <p ng-if="!showAcceptanceAlert"> {accept-terms-and-conditions-body} </p> <p style="margin-left: 44px; margin-top:8px;"> <a ng-href="{{indexingTerms}}" target="_blank">{indexing-terms}</a> <br> <a ng-href="{{contentSubmission}}" target="_blank">{content-agreement}</a> </p> </idx-terms-and-conditions-modal-body>',

    // Included template file: ../templates/idxCommonModal.html
    "idxCommonModal": '<idx-common-modal class="modal hide fade modal-absolute-positioning" ng-class="modalClass"> <div ng-class="alertClass"> <div ng-class="headerClass"> <button type="button" ng-if="closeButton" ng-click="close(\'closeButton\')" class="fs-dialog__close" data-dismiss="modal"></button> <h4 class="fs-alert__title">{{heading}}</h4> </div> <div ng-class="bodyClass"> <!-- You have four choices for the body: 1. body - add a string to the body - no active content 2. secureBody - html as a string - active content 3. create a directive with the name idxCommonModalBody 4. user the modal\'s injectDirective method --> <div ng-show="secureBody" ng-bind-html="secureBody" idx-secure-modal-content ng-transclude></div> <idx-common-modal-body ng-show="directiveBody"></idx-common-modal-body> <div class="injection-point" ng-show="directiveInjected"></div> <p ng-show="body">{{body}}</p> <button class="try-again fs-button" ng-class="tryAgainButton.class" ng-if="tryAgainButton.include" ng-click="tryAgainButton.handler()"> <span ng-if="tryAgainButton.text">{{tryAgainButton.text}}</span> <span ng-if="!tryAgainButton.text">{try_again_button_text}</span> </button> </div> </div> <div ng-class="footerClass"> <div class="checkbox pull-left" ng-if="hideModal.include"> <label> <input type="checkbox" ng-model="hideModal.value" ng-change="hideModal.handler(hideModal.value)"> {{hideModal.text}} </label> </div> <a href="" class="pull-left" ng-click="leftFooterLink.handler()" ng-if="leftFooterLink.include"> {{leftFooterLink.text}} </a> <a href="" class="pull-right" ng-if="rightFooterLink.include" ng-click="rightFooterLink.handler()"> {{rightFooterLink.text}} </a> <button ng-if="okButton" class="fs-button fs-button--recommended" ng-click="close(\'okButton\')">{okay}</button> <button data-test="accept-button" ng-if="primaryButton.include" class="fs-button fs-button--recommended" ng-class="primaryButton.cssClass"ng-click="primaryButton.handler(\'primaryButton\')">{{primaryButton.text}}</button> <button class="fs-button fs-button--minor" ng-if="cancelLink && !cancelLink.handler" ng-click="close(\'cancel\')">{cancel}</button> <button class="fs-button fs-button--minor" ng-if="cancelLink && cancelLink.handler" ng-class="cancelLink.cssClass" ng-click="cancelLink.handler()">{{cancelLink.text}}</button> </div> <div idx-modal-spinner class="loading-spinner loading-spinner-centered loading-spinner-naked"></div> </idx-common-modal>'
  };

  function getTemplateStr(key) {
    if (!templateList[key]) {
      console.warn("No template named '" + key + "'");
    }

    return __gca_formatStr(templateList[key] || "", lang);
  }

  var __gca_formatStrRe = /{([^}]+)}/g;
  function __gca_formatStr(txt, obj) {
  var potentialSubstitutionsRegex = /{+?[^{\n\r]+}/g;
  var trueSubstitutionsRegex = /^{([^{}]+)}/;
  if (typeof obj !== "object") {
  obj = Array.prototype.slice.call(arguments, 1);
  }
  return txt.replace(potentialSubstitutionsRegex, function (fullKey) {
  return fullKey.replace(trueSubstitutionsRegex, function(match, key) {
  var ObjArray = key.split(".");
  var len = ObjArray.length;
  var tempObj = obj;
  for (var i = 0; i < len; i++) {
  tempObj = tempObj[ObjArray[i]];
  if (!tempObj) {
  return match;
  }
  }
  return tempObj;
  });
  });
  }

  function getTemplate(key) {
    var snip = document.createElement("div");
    snip.innerHTML = getTemplateStr(key);
    if (snip.children.length > 1) { 
      throw new Error("template '" + key + "' must have exactly one root element");
    }
    return snip.firstChild;
  }

  /*
   * Included File: idxCommon.js
   */
  angular.module('idxCommon', ['IdxClient','IdxClientLogger','SecondaryNav', 'UsabillaFeedback', 'UsabillaProblem'])
    .value('platform', navigator.platform);


  /*
   * Included File: directives/idxNewProgressBar.js
   */
  /*
      Expects an HTML structure like:
   <div idx-new-progress-bar
     data-graph-type="{{'PROJECT'}}"
     data-type="{{type}}"
     data-state="{{state}}"
     data-short="{{true}}"
     data-percent-indexed="{{60}}"
     data-percent-reviewed="{{10}}"
     data-percent-batched="{{25}}"
     data-percent-batching-reviewed="{{5}}">
   */

  angular.module('idxCommon').directive('idxNewProgressBar', [function (){
    return {
      restrict: 'A',
      replace: true,
      template: '<div class="project-progress idx-project-progress-bar" ng-class="{\'short\': short}">\n  <span class="mark mark1"></span>\n  <span class="mark mark2"></span>\n  <span class="mark mark3"></span>\n  <span class="mark mark4"></span>\n  <span class="mark mark5"></span>\n  <span class="mark mark6"></span>\n  <span class="mark mark7"></span>\n  <div class="bar" data-ng-class="leftBarBackground" data-ng-style="leftBarStyle" class="pull-right">{{value}}</div>\n  <div class="bar" data-ng-class="rightBarBackground" data-ng-style="rightBarStyle"></div>\n</div>',
      scope: {
        graphType: '@', // PROJECT or BATCH
        type: '@', // INDEXING, BATCHING, INDEX_ONLY, or REVIEW_ONLY
        state: '@', // Batch state, BATCHING or REVIEWING
        short: '@', // If it is included, the number of vertical bars will be cut in half (4)
        percentIndexed: '@',
        percentIndexedByGroup: '@',
        percentReviewed: '@',
        percentReviewedByGroup: '@',
        percentBatched: '@',
        percentBatchingReviewed: '@',
        totalGroupPercent: '@'
      },
      link: function (scope, element, attrs) {
        var percentIndexed = Number(scope.percentIndexed);
        var percentIndexedByGroup = Number(scope.percentIndexedByGroup);
        var percentReviewed = Number(scope.percentReviewed);
        var percentReviewedByGroup = Number(scope.percentReviewedByGroup);
        var percentBatched = Number(scope.percentBatched);
        var percentBatchingReviewed = Number(scope.percentBatchingReviewed);

        // Always calculate the bar graphs
        calculateStyles();

        // Used to watch the change of the group's total goal to draw the bar graph
        attrs.$observe('totalGroupPercent', function (value) {
          if (value <= 100) {
            calculateStyles(value);
          }
        });

        function calculateStyles(changedGroupPercent) {
          if (changedGroupPercent) {
            percentIndexedByGroup = Number(changedGroupPercent)
          }

          // Used to display percent on the bar graph itself. Always default empty, so it doesn't show
          scope.value = ''

          if (scope.graphType === 'PROJECT') {
            switch (scope.type) {
              case 'INDEXING':
                if (percentIndexedByGroup) {
                  if (changedGroupPercent) {
                    scope.leftBarStyle = {'width': percentIndexedByGroup + '%', 'z-index': '15', 'text-align': 'right', 'font-size': '14px', 'line-height': '16px', 'font-weight': 'bold'};
                    scope.value = Math.round(changedGroupPercent) + '%\xa0'; // Add non-breaking space
                  } else {
                  scope.leftBarStyle = {'width': percentIndexedByGroup + '%', 'z-index': '15'}; // hard coded fs-styles color
                  }
                  scope.rightBarStyle = {'width': percentIndexed + '%', 'z-index': '10'}; // hard coded fs-styles color $color-orange-accent-light 60%
                  scope.leftBarBackground = 'background-color-orange-accent';
                  scope.rightBarBackground = 'background-color-orange-accent-lighten-60';
                } else if (percentReviewedByGroup) {
                  scope.leftBarStyle = {'width': percentReviewedByGroup + '%', 'z-index': '15'}; // hard coded fs-styles color
                  scope.rightBarStyle = {'width': percentReviewed + '%', 'z-index': '10'}; // hard coded fs-styles color $color-red-accent-light 60%
                  scope.leftBarBackground = 'background-color-red-accent';
                  scope.rightBarBackground = 'background-color-red-accent-lighten-60';
                } else {
                  scope.leftBarStyle = {'width': percentIndexed + '%', 'z-index': '10'}; // hard coded fs-styles color
                  scope.rightBarStyle = {'width': percentReviewed + '%', 'z-index': '15'}; // hard coded fs-styles color
                  scope.leftBarBackground = 'background-color-orange-accent';
                  scope.rightBarBackground = 'background-color-red-accent';
                }
                break;
              case 'INDEXING_ONLY':
                scope.leftBarStyle = {'width': percentIndexed + '%'};
                scope.rightBarStyle = {'display': 'none'};
                scope.leftBarBackground = 'background-color-orange-accent';
                break;
              case 'REVIEW_ONLY':
                scope.leftBarStyle = {'display': 'none'};
                scope.rightBarStyle = {'width': percentReviewed + '%'};
                scope.rightBarBackground = 'background-color-red-accent';
                break;
              default:
                scope.leftBarStyle = {'width': percentBatched + '%', 'z-index': '10'}; // hard coded fs-styles color
                scope.rightBarStyle = {'width': percentBatchingReviewed + '%', 'z-index': '15'}; // hard coded fs-styles color
                scope.leftBarBackground = 'background-color-green-accent';
                scope.rightBarBackground = 'background-color-blue-accent';
                break;
            }
          } else if (scope.graphType === 'BATCH') {
            if (scope.state.indexOf('BATCH') > -1) {
              scope.leftBarStyle = {'width': percentBatched + '%', 'z-index': '10'}; // hard coded fs-styles color
              scope.rightBarStyle = {'width': percentBatchingReviewed + '%', 'z-index': '15'}; // hard coded fs-styles color
              scope.leftBarBackground = 'background-color-green-accent';
              scope.rightBarBackground = 'background-color-blue-accent';
            } else {
              scope.leftBarStyle = {'width': percentIndexed + '%', 'z-index': '10'}; // hard coded fs-styles color
              scope.rightBarStyle = {'width': percentReviewed + '%', 'z-index': '15'}; // hard coded fs-styles color
              scope.leftBarBackground = 'background-color-orange-accent';
              scope.rightBarBackground = 'background-color-red-accent';
            }
          }
        }
      }
    };
  }]);


  /*
   * Included File: directives/idxSiteCatalyst.js
   */
  /**
   * Add the idx-site-catalyst directive attribute on any element you wish to be tracked.
   * Point the directive name to a JavaScript object. For example:
   * <button idx-site-catalyst='{type: "o", name: "Indexing: Indexing Tool: Field Help Toolbar: {{fieldHelp.name}}"}'>Button</button>
   * If you omit type, it will default to "o". The proper types are "o" for link, "e" for exit and "d" for download.
   * if you want to fire an event, add an event to the event list, which is a comma separated list of events.
   * if you want to set a property, add it in a props array with a value, e.g., [{number: 42, value: "Foo"}].
   */
  angular.module('idxCommon')
    .directive('idxSiteCatalyst', ['$log', function ($log) {
      return {
        restrict: 'A',
        scope: {
          config: '@idxSiteCatalyst'
        },
        link: function ($scope, $element, attrs) {
          $element.on('click', function (evt) {
            try {
              var config = $scope.$eval($scope.config) || {};

              var type = config.hasOwnProperty('type') ? config.type : "o";
              var name = config.hasOwnProperty('name') ? config.name : null;
              var events = config.hasOwnProperty('events') ? config.events : null;
              var props = config.hasOwnProperty('props') ? config.props : null;

              if (typeof s !== 'undefined') {
                if (events) {
                  s.events = events;
                }

                if (props) {
                  props.forEach(function(prop){
                    s['prop' + prop.number] = prop.value;
                  });
                }

                if (events || props) {
                  s.t();
                }

                if (name) {
                  s.tl($element[0], type, name);
                }
              }
            }
            catch (err) {
              $log.warn('idxSiteCatalyst directive error:', err);
            }
          });
        }
      }
    }]);


  /*
   * Included File: directives/ng-tags-input.es6
   */
  // Plugin: transpileEs6
  /**
   * This file has been modified from the 3.1.1 version at http://mbenford.github.io/ngTagsInput
   * The changes involving adding support for semicolons to work the same as commas
   * as a tag-separating character, so the only changes are the 3 lines with the word semicolon in them.
   */

  /*!
   * ngTagsInput v3.1.1
   * http://mbenford.github.io/ngTagsInput
   *
   * Copyright (c) 2013-2016 Michael Benford
   * License: MIT
   *
   * Generated at 2016-05-27 12:28:31 -0300
   */
  (function () {

      var KEYS = {
          backspace: 8,
          tab: 9,
          enter: 13,
          escape: 27,
          space: 32,
          up: 38,
          down: 40,
          left: 37,
          right: 39,
          delete: 46,
          comma: 188,
          semicolon: 186
      };

      var MAX_SAFE_INTEGER = 9007199254740991;
      var SUPPORTED_INPUT_TYPES = ['text', 'email', 'url'];

      var tagsInput = angular.module('ngTagsInput', []);

      /**
       * @ngdoc directive
       * @name tagsInput
       * @module ngTagsInput
       *
       * @description
       * Renders an input box with tag editing support.
       *
       * @param {string} ngModel Assignable Angular expression to data-bind to.
       * @param {string=} [template=NA] URL or id of a custom template for rendering each tag.
       * @param {string=} [templateScope=NA] Scope to be passed to custom templates - of both tagsInput and
       *    autoComplete directives - as $scope.
       * @param {string=} [displayProperty=text] Property to be rendered as the tag label.
       * @param {string=} [keyProperty=text] Property to be used as a unique identifier for the tag.
       * @param {string=} [type=text] Type of the input element. Only 'text', 'email' and 'url' are supported values.
       * @param {string=} [text=NA] Assignable Angular expression for data-binding to the element's text.
       * @param {number=} tabindex Tab order of the control.
       * @param {string=} [placeholder=Add a tag] Placeholder text for the control.
       * @param {number=} [minLength=3] Minimum length for a new tag.
       * @param {number=} [maxLength=MAX_SAFE_INTEGER] Maximum length allowed for a new tag.
       * @param {number=} [minTags=0] Sets minTags validation error key if the number of tags added is less than minTags.
       * @param {number=} [maxTags=MAX_SAFE_INTEGER] Sets maxTags validation error key if the number of tags added is greater
       *    than maxTags.
       * @param {boolean=} [allowLeftoverText=false] Sets leftoverText validation error key if there is any leftover text in
       *    the input element when the directive loses focus.
       * @param {string=} [removeTagSymbol=×] (Obsolete) Symbol character for the remove tag button.
       * @param {boolean=} [addOnEnter=true] Flag indicating that a new tag will be added on pressing the ENTER key.
       * @param {boolean=} [addOnSpace=false] Flag indicating that a new tag will be added on pressing the SPACE key.
       * @param {boolean=} [addOnComma=true] Flag indicating that a new tag will be added on pressing the COMMA key.
       * @param {boolean=} [addOnBlur=true] Flag indicating that a new tag will be added when the input field loses focus.
       * @param {boolean=} [addOnPaste=false] Flag indicating that the text pasted into the input field will be split into tags.
       * @param {string=} [pasteSplitPattern=,] Regular expression used to split the pasted text into tags.
       * @param {boolean=} [replaceSpacesWithDashes=true] Flag indicating that spaces will be replaced with dashes.
       * @param {string=} [allowedTagsPattern=.+] Regular expression that determines whether a new tag is valid.
       * @param {boolean=} [enableEditingLastTag=false] Flag indicating that the last tag will be moved back into the new tag
       *    input box instead of being removed when the backspace key is pressed and the input box is empty.
       * @param {boolean=} [addFromAutocompleteOnly=false] Flag indicating that only tags coming from the autocomplete list
       *    will be allowed. When this flag is true, addOnEnter, addOnComma, addOnSpace and addOnBlur values are ignored.
       * @param {boolean=} [spellcheck=true] Flag indicating whether the browser's spellcheck is enabled for the input field or not.
       * @param {boolean=} [readOnly=false] Flag indicating whether the input field is editable or not.
       * @param {expression=} [tagClass=NA] Expression to evaluate for each existing tag in order to get the CSS classes to be used.
       *    The expression is provided with the current tag as $tag, its index as $index and its state as $selected. The result
       *    of the evaluation must be one of the values supported by the ngClass directive (either a string, an array or an object).
       *    See https://docs.angularjs.org/api/ng/directive/ngClass for more information.
       * @param {expression=} [onTagAdding=NA] Expression to evaluate that will be invoked before adding a new tag. The new
       *    tag is available as $tag. This method must return either a boolean value or a promise. If either a false value or a rejected
       *    promise is returned, the tag will not be added.
       * @param {expression=} [onTagAdded=NA] Expression to evaluate upon adding a new tag. The new tag is available as $tag.
       * @param {expression=} [onInvalidTag=NA] Expression to evaluate when a tag is invalid. The invalid tag is available as $tag.
       * @param {expression=} [onTagRemoving=NA] Expression to evaluate that will be invoked before removing a tag. The tag
       *    is available as $tag. This method must return either a boolean value or a promise. If either a false value or a rejected
       *    promise is returned, the tag will not be removed.
       * @param {expression=} [onTagRemoved=NA] Expression to evaluate upon removing an existing tag. The removed tag is available as $tag.
       * @param {expression=} [onTagClicked=NA] Expression to evaluate upon clicking an existing tag. The clicked tag is available as $tag.
       */
      tagsInput.directive('tagsInput', ["$timeout", "$document", "$window", "$q", "tagsInputConfig", "tiUtil", function ($timeout, $document, $window, $q, tagsInputConfig, tiUtil) {
          function TagList(options, events, onTagAdding, onTagRemoving) {
              var self = {},
                  getTagText,
                  setTagText,
                  canAddTag,
                  canRemoveTag;

              getTagText = function (tag) {
                  return tiUtil.safeToString(tag[options.displayProperty]);
              };

              setTagText = function (tag, text) {
                  tag[options.displayProperty] = text;
              };

              canAddTag = function (tag) {
                  var tagText = getTagText(tag);
                  var valid = tagText && tagText.length >= options.minLength && tagText.length <= options.maxLength && options.allowedTagsPattern.test(tagText) && !tiUtil.findInObjectArray(self.items, tag, options.keyProperty || options.displayProperty);

                  return $q.when(valid && onTagAdding({ $tag: tag })).then(tiUtil.promisifyValue);
              };

              canRemoveTag = function (tag) {
                  return $q.when(onTagRemoving({ $tag: tag })).then(tiUtil.promisifyValue);
              };

              self.items = [];

              self.addText = function (text) {
                  var tag = {};
                  setTagText(tag, text);
                  return self.add(tag);
              };

              self.add = function (tag) {
                  var tagText = getTagText(tag);

                  if (options.replaceSpacesWithDashes) {
                      tagText = tiUtil.replaceSpacesWithDashes(tagText);
                  }

                  setTagText(tag, tagText);

                  return canAddTag(tag).then(function () {
                      self.items.push(tag);
                      events.trigger('tag-added', { $tag: tag });
                  }).catch(function () {
                      if (tagText) {
                          events.trigger('invalid-tag', { $tag: tag });
                      }
                  });
              };

              self.remove = function (index) {
                  var tag = self.items[index];

                  return canRemoveTag(tag).then(function () {
                      self.items.splice(index, 1);
                      self.clearSelection();
                      events.trigger('tag-removed', { $tag: tag });
                      return tag;
                  });
              };

              self.select = function (index) {
                  if (index < 0) {
                      index = self.items.length - 1;
                  } else if (index >= self.items.length) {
                      index = 0;
                  }

                  self.index = index;
                  self.selected = self.items[index];
              };

              self.selectPrior = function () {
                  self.select(--self.index);
              };

              self.selectNext = function () {
                  self.select(++self.index);
              };

              self.removeSelected = function () {
                  return self.remove(self.index);
              };

              self.clearSelection = function () {
                  self.selected = null;
                  self.index = -1;
              };

              self.clearSelection();

              return self;
          }

          function validateType(type) {
              return SUPPORTED_INPUT_TYPES.indexOf(type) !== -1;
          }

          return {
              restrict: 'E',
              require: 'ngModel',
              scope: {
                  tags: '=ngModel',
                  text: '=?',
                  templateScope: '=?',
                  tagClass: '&',
                  onTagAdding: '&',
                  onTagAdded: '&',
                  onInvalidTag: '&',
                  onTagRemoving: '&',
                  onTagRemoved: '&',
                  onTagClicked: '&',
                  readOnly: '@?'
              },
              replace: false,
              transclude: true,
              templateUrl: 'ngTagsInput/tags-input.html',
              controller: ["$scope", "$attrs", "$element", function ($scope, $attrs, $element) {
                  $scope.events = tiUtil.simplePubSub();

                  tagsInputConfig.load('tagsInput', $scope, $attrs, {
                      template: [String, 'ngTagsInput/tag-item.html'],
                      type: [String, 'text', validateType],
                      placeholder: [String, 'Add a tag'],
                      tabindex: [Number, null],
                      removeTagSymbol: [String, String.fromCharCode(215)],
                      replaceSpacesWithDashes: [Boolean, true],
                      minLength: [Number, 3],
                      maxLength: [Number, MAX_SAFE_INTEGER],
                      addOnEnter: [Boolean, true],
                      addOnSpace: [Boolean, false],
                      addOnComma: [Boolean, true],
                      addOnBlur: [Boolean, true],
                      addOnPaste: [Boolean, false],
                      pasteSplitPattern: [RegExp, /,/],
                      allowedTagsPattern: [RegExp, /.+/],
                      enableEditingLastTag: [Boolean, false],
                      minTags: [Number, 0],
                      maxTags: [Number, MAX_SAFE_INTEGER],
                      displayProperty: [String, 'text'],
                      keyProperty: [String, ''],
                      allowLeftoverText: [Boolean, false],
                      addFromAutocompleteOnly: [Boolean, false],
                      spellcheck: [Boolean, true],
                      readOnly: [Boolean, false]
                  });

                  $scope.tagList = new TagList($scope.options, $scope.events, tiUtil.handleUndefinedResult($scope.onTagAdding, true), tiUtil.handleUndefinedResult($scope.onTagRemoving, true));

                  this.registerAutocomplete = function () {
                      var input = $element.find('input');

                      return {
                          addTag: function (tag) {
                              return $scope.tagList.add(tag);
                          },
                          getTags: function () {
                              return $scope.tagList.items;
                          },
                          getCurrentTagText: function () {
                              return $scope.newTag.text();
                          },
                          getOptions: function () {
                              return $scope.options;
                          },
                          getTemplateScope: function () {
                              return $scope.templateScope;
                          },
                          on: function (name, handler) {
                              $scope.events.on(name, handler, true);
                              return this;
                          }
                      };
                  };

                  this.registerTagItem = function () {
                      return {
                          getOptions: function () {
                              return $scope.options;
                          },
                          removeTag: function (index) {
                              if ($scope.disabled) {
                                  return;
                              }
                              $scope.tagList.remove(index);
                          }
                      };
                  };
              }],
              link: function (scope, element, attrs, ngModelCtrl) {
                  var hotkeys = [KEYS.enter, KEYS.comma, KEYS.semicolon, KEYS.space, KEYS.backspace, KEYS.delete, KEYS.left, KEYS.right],
                      tagList = scope.tagList,
                      events = scope.events,
                      options = scope.options,
                      input = element.find('input'),
                      validationOptions = ['minTags', 'maxTags', 'allowLeftoverText'],
                      setElementValidity,
                      focusInput;

                  setElementValidity = function () {
                      ngModelCtrl.$setValidity('maxTags', tagList.items.length <= options.maxTags);
                      ngModelCtrl.$setValidity('minTags', tagList.items.length >= options.minTags);
                      ngModelCtrl.$setValidity('leftoverText', scope.hasFocus || options.allowLeftoverText ? true : !scope.newTag.text());
                  };

                  focusInput = function () {
                      $timeout(function () {
                          input[0].focus();
                      });
                  };

                  ngModelCtrl.$isEmpty = function (value) {
                      return !value || !value.length;
                  };

                  scope.newTag = {
                      text: function (value) {
                          if (angular.isDefined(value)) {
                              scope.text = value;
                              events.trigger('input-change', value);
                          } else {
                              return scope.text || '';
                          }
                      },
                      invalid: null
                  };

                  scope.track = function (tag) {
                      return tag[options.keyProperty || options.displayProperty];
                  };

                  scope.getTagClass = function (tag, index) {
                      var selected = tag === tagList.selected;
                      return [scope.tagClass({ $tag: tag, $index: index, $selected: selected }), { selected: selected }];
                  };

                  scope.$watch('tags', function (value) {
                      if (value) {
                          tagList.items = tiUtil.makeObjectArray(value, options.displayProperty);
                          scope.tags = tagList.items;
                      } else {
                          tagList.items = [];
                      }
                  });

                  scope.$watch('tags.length', function () {
                      setElementValidity();

                      // ngModelController won't trigger validators when the model changes (because it's an array),
                      // so we need to do it ourselves. Unfortunately this won't trigger any registered formatter.
                      ngModelCtrl.$validate();
                  });

                  attrs.$observe('disabled', function (value) {
                      scope.disabled = value;
                  });

                  scope.eventHandlers = {
                      input: {
                          keydown: function ($event) {
                              events.trigger('input-keydown', $event);
                          },
                          focus: function () {
                              if (scope.hasFocus) {
                                  return;
                              }

                              scope.hasFocus = true;
                              events.trigger('input-focus');
                          },
                          blur: function () {
                              $timeout(function () {
                                  var activeElement = $document.prop('activeElement'),
                                      lostFocusToBrowserWindow = activeElement === input[0],
                                      lostFocusToChildElement = element[0].contains(activeElement);

                                  if (lostFocusToBrowserWindow || !lostFocusToChildElement) {
                                      scope.hasFocus = false;
                                      events.trigger('input-blur');
                                  }
                              });
                          },
                          paste: function ($event) {
                              $event.getTextData = function () {
                                  var clipboardData = $event.clipboardData || $event.originalEvent && $event.originalEvent.clipboardData;
                                  return clipboardData ? clipboardData.getData('text/plain') : $window.clipboardData.getData('Text');
                              };
                              events.trigger('input-paste', $event);
                          }
                      },
                      host: {
                          click: function () {
                              if (scope.disabled) {
                                  return;
                              }
                              focusInput();
                          }
                      },
                      tag: {
                          click: function (tag) {
                              events.trigger('tag-clicked', { $tag: tag });
                          }
                      }
                  };

                  events.on('tag-added', scope.onTagAdded).on('invalid-tag', scope.onInvalidTag).on('tag-removed', scope.onTagRemoved).on('tag-clicked', scope.onTagClicked).on('tag-added', function () {
                      scope.newTag.text('');
                  }).on('tag-added tag-removed', function () {
                      scope.tags = tagList.items;
                      // Ideally we should be able call $setViewValue here and let it in turn call $setDirty and $validate
                      // automatically, but since the model is an array, $setViewValue does nothing and it's up to us to do it.
                      // Unfortunately this won't trigger any registered $parser and there's no safe way to do it.
                      ngModelCtrl.$setDirty();
                      focusInput();
                  }).on('invalid-tag', function () {
                      scope.newTag.invalid = true;
                  }).on('option-change', function (e) {
                      if (validationOptions.indexOf(e.name) !== -1) {
                          setElementValidity();
                      }
                  }).on('input-change', function () {
                      tagList.clearSelection();
                      scope.newTag.invalid = null;
                  }).on('input-focus', function () {
                      element.triggerHandler('focus');
                      ngModelCtrl.$setValidity('leftoverText', true);
                  }).on('input-blur', function () {
                      if (options.addOnBlur && !options.addFromAutocompleteOnly) {
                          tagList.addText(scope.newTag.text());
                      }
                      element.triggerHandler('blur');
                      setElementValidity();
                  }).on('input-keydown', function (event) {
                      var key = event.keyCode,
                          addKeys = {},
                          shouldAdd,
                          shouldRemove,
                          shouldSelect,
                          shouldEditLastTag;

                      if (tiUtil.isModifierOn(event) || hotkeys.indexOf(key) === -1) {
                          return;
                      }

                      addKeys[KEYS.enter] = options.addOnEnter;
                      addKeys[KEYS.comma] = options.addOnComma;
                      addKeys[KEYS.semicolon] = options.addOnComma;
                      addKeys[KEYS.space] = options.addOnSpace;

                      shouldAdd = !options.addFromAutocompleteOnly && addKeys[key];
                      shouldRemove = (key === KEYS.backspace || key === KEYS.delete) && tagList.selected;
                      shouldEditLastTag = key === KEYS.backspace && scope.newTag.text().length === 0 && options.enableEditingLastTag;
                      shouldSelect = (key === KEYS.backspace || key === KEYS.left || key === KEYS.right) && scope.newTag.text().length === 0 && !options.enableEditingLastTag;

                      if (shouldAdd) {
                          tagList.addText(scope.newTag.text());
                      } else if (shouldEditLastTag) {
                          tagList.selectPrior();
                          tagList.removeSelected().then(function (tag) {
                              if (tag) {
                                  scope.newTag.text(tag[options.displayProperty]);
                              }
                          });
                      } else if (shouldRemove) {
                          tagList.removeSelected();
                      } else if (shouldSelect) {
                          if (key === KEYS.left || key === KEYS.backspace) {
                              tagList.selectPrior();
                          } else if (key === KEYS.right) {
                              tagList.selectNext();
                          }
                      }

                      if (shouldAdd || shouldSelect || shouldRemove || shouldEditLastTag) {
                          event.preventDefault();
                      }
                  }).on('input-paste', function (event) {
                      if (options.addOnPaste) {
                          var data = event.getTextData();
                          var tags = data.split(options.pasteSplitPattern);

                          if (tags.length > 1) {
                              tags.forEach(function (tag) {
                                  tagList.addText(tag);
                              });
                              event.preventDefault();
                          }
                      }
                  });
              }
          };
      }]);

      /**
       * @ngdoc directive
       * @name tiTagItem
       * @module ngTagsInput
       *
       * @description
       * Represents a tag item. Used internally by the tagsInput directive.
       */
      tagsInput.directive('tiTagItem', ["tiUtil", function (tiUtil) {
          return {
              restrict: 'E',
              require: '^tagsInput',
              template: '<ng-include src="$$template"></ng-include>',
              scope: {
                  $scope: '=scope',
                  data: '=',
                  readOnly: '@?'
              },
              link: function (scope, element, attrs, tagsInputCtrl) {
                  var tagsInput = tagsInputCtrl.registerTagItem(),
                      options = tagsInput.getOptions();

                  scope.$$template = options.template;
                  scope.$$removeTagSymbol = options.removeTagSymbol;

                  scope.$getDisplayText = function () {
                      return tiUtil.safeToString(scope.data[options.displayProperty]);
                  };
                  scope.$removeTag = function () {
                      tagsInput.removeTag(scope.$index);
                  };

                  scope.$watch('$parent.$index', function (value) {
                      scope.$index = value;
                  });
              }
          };
      }]);

      /**
       * @ngdoc directive
       * @name autoComplete
       * @module ngTagsInput
       *
       * @description
       * Provides autocomplete support for the tagsInput directive.
       *
       * @param {expression} source Expression to evaluate upon changing the input content. The input value is available as
       *    $query. The result of the expression must be a promise that eventually resolves to an array of strings.
       * @param {string=} [template=NA] URL or id of a custom template for rendering each element of the autocomplete list.
       * @param {string=} [displayProperty=tagsInput.displayText] Property to be rendered as the autocomplete label.
       * @param {number=} [debounceDelay=100] Amount of time, in milliseconds, to wait before evaluating the expression in
       *    the source option after the last keystroke.
       * @param {number=} [minLength=3] Minimum number of characters that must be entered before evaluating the expression
       *    in the source option.
       * @param {boolean=} [highlightMatchedText=true] Flag indicating that the matched text will be highlighted in the
       *    suggestions list.
       * @param {number=} [maxResultsToShow=10] Maximum number of results to be displayed at a time.
       * @param {boolean=} [loadOnDownArrow=false] Flag indicating that the source option will be evaluated when the down arrow
       *    key is pressed and the suggestion list is closed. The current input value is available as $query.
       * @param {boolean=} [loadOnEmpty=false] Flag indicating that the source option will be evaluated when the input content
       *    becomes empty. The $query variable will be passed to the expression as an empty string.
       * @param {boolean=} [loadOnFocus=false] Flag indicating that the source option will be evaluated when the input element
       *    gains focus. The current input value is available as $query.
       * @param {boolean=} [selectFirstMatch=true] Flag indicating that the first match will be automatically selected once
       *    the suggestion list is shown.
       * @param {expression=} [matchClass=NA] Expression to evaluate for each match in order to get the CSS classes to be used.
       *    The expression is provided with the current match as $match, its index as $index and its state as $selected. The result
       *    of the evaluation must be one of the values supported by the ngClass directive (either a string, an array or an object).
       *    See https://docs.angularjs.org/api/ng/directive/ngClass for more information.
       */
      tagsInput.directive('autoComplete', ["$document", "$timeout", "$sce", "$q", "tagsInputConfig", "tiUtil", function ($document, $timeout, $sce, $q, tagsInputConfig, tiUtil) {
          function SuggestionList(loadFn, options, events) {
              var self = {},
                  getDifference,
                  lastPromise,
                  getTagId;

              getTagId = function () {
                  return options.tagsInput.keyProperty || options.tagsInput.displayProperty;
              };

              getDifference = function (array1, array2) {
                  return array1.filter(function (item) {
                      return !tiUtil.findInObjectArray(array2, item, getTagId(), function (a, b) {
                          if (options.tagsInput.replaceSpacesWithDashes) {
                              a = tiUtil.replaceSpacesWithDashes(a);
                              b = tiUtil.replaceSpacesWithDashes(b);
                          }
                          return tiUtil.defaultComparer(a, b);
                      });
                  });
              };

              self.reset = function () {
                  lastPromise = null;

                  self.items = [];
                  self.visible = false;
                  self.index = -1;
                  self.selected = null;
                  self.query = null;
              };
              self.show = function () {
                  if (options.selectFirstMatch) {
                      self.select(0);
                  } else {
                      self.selected = null;
                  }
                  self.visible = true;
              };
              self.load = tiUtil.debounce(function (query, tags) {
                  self.query = query;

                  var promise = $q.when(loadFn({ $query: query }));
                  lastPromise = promise;

                  promise.then(function (items) {
                      if (promise !== lastPromise) {
                          return;
                      }

                      items = tiUtil.makeObjectArray(items.data || items, getTagId());
                      items = getDifference(items, tags);
                      self.items = items.slice(0, options.maxResultsToShow);

                      if (self.items.length > 0) {
                          self.show();
                      } else {
                          self.reset();
                      }
                  });
              }, options.debounceDelay);

              self.selectNext = function () {
                  self.select(++self.index);
              };
              self.selectPrior = function () {
                  self.select(--self.index);
              };
              self.select = function (index) {
                  if (index < 0) {
                      index = self.items.length - 1;
                  } else if (index >= self.items.length) {
                      index = 0;
                  }
                  self.index = index;
                  self.selected = self.items[index];
                  events.trigger('suggestion-selected', index);
              };

              self.reset();

              return self;
          }

          function scrollToElement(root, index) {
              var element = root.find('li').eq(index),
                  parent = element.parent(),
                  elementTop = element.prop('offsetTop'),
                  elementHeight = element.prop('offsetHeight'),
                  parentHeight = parent.prop('clientHeight'),
                  parentScrollTop = parent.prop('scrollTop');

              if (elementTop < parentScrollTop) {
                  parent.prop('scrollTop', elementTop);
              } else if (elementTop + elementHeight > parentHeight + parentScrollTop) {
                  parent.prop('scrollTop', elementTop + elementHeight - parentHeight);
              }
          }

          return {
              restrict: 'E',
              require: '^tagsInput',
              scope: {
                  source: '&',
                  matchClass: '&'
              },
              templateUrl: 'ngTagsInput/auto-complete.html',
              controller: ["$scope", "$element", "$attrs", function ($scope, $element, $attrs) {
                  $scope.events = tiUtil.simplePubSub();

                  tagsInputConfig.load('autoComplete', $scope, $attrs, {
                      template: [String, 'ngTagsInput/auto-complete-match.html'],
                      debounceDelay: [Number, 100],
                      minLength: [Number, 3],
                      highlightMatchedText: [Boolean, true],
                      maxResultsToShow: [Number, 10],
                      loadOnDownArrow: [Boolean, false],
                      loadOnEmpty: [Boolean, false],
                      loadOnFocus: [Boolean, false],
                      selectFirstMatch: [Boolean, true],
                      displayProperty: [String, '']
                  });

                  $scope.suggestionList = new SuggestionList($scope.source, $scope.options, $scope.events);

                  this.registerAutocompleteMatch = function () {
                      return {
                          getOptions: function () {
                              return $scope.options;
                          },
                          getQuery: function () {
                              return $scope.suggestionList.query;
                          }
                      };
                  };
              }],
              link: function (scope, element, attrs, tagsInputCtrl) {
                  var hotkeys = [KEYS.enter, KEYS.tab, KEYS.escape, KEYS.up, KEYS.down],
                      suggestionList = scope.suggestionList,
                      tagsInput = tagsInputCtrl.registerAutocomplete(),
                      options = scope.options,
                      events = scope.events,
                      shouldLoadSuggestions;

                  options.tagsInput = tagsInput.getOptions();

                  shouldLoadSuggestions = function (value) {
                      return value && value.length >= options.minLength || !value && options.loadOnEmpty;
                  };

                  scope.templateScope = tagsInput.getTemplateScope();

                  scope.addSuggestionByIndex = function (index) {
                      suggestionList.select(index);
                      scope.addSuggestion();
                  };

                  scope.addSuggestion = function () {
                      var added = false;

                      if (suggestionList.selected) {
                          tagsInput.addTag(angular.copy(suggestionList.selected));
                          suggestionList.reset();
                          added = true;
                      }
                      return added;
                  };

                  scope.track = function (item) {
                      return item[options.tagsInput.keyProperty || options.tagsInput.displayProperty];
                  };

                  scope.getSuggestionClass = function (item, index) {
                      var selected = item === suggestionList.selected;
                      return [scope.matchClass({ $match: item, $index: index, $selected: selected }), { selected: selected }];
                  };

                  tagsInput.on('tag-added tag-removed invalid-tag input-blur', function () {
                      suggestionList.reset();
                  }).on('input-change', function (value) {
                      if (shouldLoadSuggestions(value)) {
                          suggestionList.load(value, tagsInput.getTags());
                      } else {
                          suggestionList.reset();
                      }
                  }).on('input-focus', function () {
                      var value = tagsInput.getCurrentTagText();
                      if (options.loadOnFocus && shouldLoadSuggestions(value)) {
                          suggestionList.load(value, tagsInput.getTags());
                      }
                  }).on('input-keydown', function (event) {
                      var key = event.keyCode,
                          handled = false;

                      if (tiUtil.isModifierOn(event) || hotkeys.indexOf(key) === -1) {
                          return;
                      }

                      if (suggestionList.visible) {

                          if (key === KEYS.down) {
                              suggestionList.selectNext();
                              handled = true;
                          } else if (key === KEYS.up) {
                              suggestionList.selectPrior();
                              handled = true;
                          } else if (key === KEYS.escape) {
                              suggestionList.reset();
                              handled = true;
                          } else if (key === KEYS.enter || key === KEYS.tab) {
                              handled = scope.addSuggestion();
                          }
                      } else {
                          if (key === KEYS.down && scope.options.loadOnDownArrow) {
                              suggestionList.load(tagsInput.getCurrentTagText(), tagsInput.getTags());
                              handled = true;
                          }
                      }

                      if (handled) {
                          event.preventDefault();
                          event.stopImmediatePropagation();
                          return false;
                      }
                  });

                  events.on('suggestion-selected', function (index) {
                      scrollToElement(element, index);
                  });
              }
          };
      }]);

      /**
       * @ngdoc directive
       * @name tiAutocompleteMatch
       * @module ngTagsInput
       *
       * @description
       * Represents an autocomplete match. Used internally by the autoComplete directive.
       */
      tagsInput.directive('tiAutocompleteMatch', ["$sce", "tiUtil", function ($sce, tiUtil) {
          return {
              restrict: 'E',
              require: '^autoComplete',
              template: '<ng-include src="$$template"></ng-include>',
              scope: {
                  $scope: '=scope',
                  data: '='
              },
              link: function (scope, element, attrs, autoCompleteCtrl) {
                  var autoComplete = autoCompleteCtrl.registerAutocompleteMatch(),
                      options = autoComplete.getOptions();

                  scope.$$template = options.template;
                  scope.$index = scope.$parent.$index;

                  scope.$highlight = function (text) {
                      if (options.highlightMatchedText) {
                          text = tiUtil.safeHighlight(text, autoComplete.getQuery());
                      }
                      return $sce.trustAsHtml(text);
                  };
                  scope.$getDisplayText = function () {
                      return tiUtil.safeToString(scope.data[options.displayProperty || options.tagsInput.displayProperty]);
                  };
              }
          };
      }]);

      /**
       * @ngdoc directive
       * @name tiTranscludeAppend
       * @module ngTagsInput
       *
       * @description
       * Re-creates the old behavior of ng-transclude. Used internally by tagsInput directive.
       */
      tagsInput.directive('tiTranscludeAppend', function () {
          return function (scope, element, attrs, ctrl, transcludeFn) {
              transcludeFn(function (clone) {
                  element.append(clone);
              });
          };
      });

      /**
       * @ngdoc directive
       * @name tiAutosize
       * @module ngTagsInput
       *
       * @description
       * Automatically sets the input's width so its content is always visible. Used internally by tagsInput directive.
       */
      tagsInput.directive('tiAutosize', ["tagsInputConfig", function (tagsInputConfig) {
          return {
              restrict: 'A',
              require: 'ngModel',
              link: function (scope, element, attrs, ctrl) {
                  var threshold = tagsInputConfig.getTextAutosizeThreshold(),
                      span,
                      resize;

                  span = angular.element('<span class="input"></span>');
                  span.css('display', 'none').css('visibility', 'hidden').css('width', 'auto').css('white-space', 'pre');

                  element.parent().append(span);

                  resize = function (originalValue) {
                      var value = originalValue,
                          width;

                      if (angular.isString(value) && value.length === 0) {
                          value = attrs.placeholder;
                      }

                      if (value) {
                          span.text(value);
                          span.css('display', '');
                          width = span.prop('offsetWidth');
                          span.css('display', 'none');
                      }

                      element.css('width', width ? width + threshold + 'px' : '');

                      return originalValue;
                  };

                  ctrl.$parsers.unshift(resize);
                  ctrl.$formatters.unshift(resize);

                  attrs.$observe('placeholder', function (value) {
                      if (!ctrl.$modelValue) {
                          resize(value);
                      }
                  });
              }
          };
      }]);

      /**
       * @ngdoc directive
       * @name tiBindAttrs
       * @module ngTagsInput
       *
       * @description
       * Binds attributes to expressions. Used internally by tagsInput directive.
       */
      tagsInput.directive('tiBindAttrs', function () {
          return function (scope, element, attrs) {
              scope.$watch(attrs.tiBindAttrs, function (value) {
                  angular.forEach(value, function (value, key) {
                      attrs.$set(key, value);
                  });
              }, true);
          };
      });

      /**
       * @ngdoc service
       * @name tagsInputConfig
       * @module ngTagsInput
       *
       * @description
       * Sets global configuration settings for both tagsInput and autoComplete directives. It's also used internally to parse and
       *  initialize options from HTML attributes.
       */
      tagsInput.provider('tagsInputConfig', function () {
          var globalDefaults = {},
              interpolationStatus = {},
              autosizeThreshold = 3;

          /**
           * @ngdoc method
           * @name tagsInputConfig#setDefaults
           * @description Sets the default configuration option for a directive.
           *
           * @param {string} directive Name of the directive to be configured. Must be either 'tagsInput' or 'autoComplete'.
           * @param {object} defaults Object containing options and their values.
           *
           * @returns {object} The service itself for chaining purposes.
           */
          this.setDefaults = function (directive, defaults) {
              globalDefaults[directive] = defaults;
              return this;
          };

          /**
           * @ngdoc method
           * @name tagsInputConfig#setActiveInterpolation
           * @description Sets active interpolation for a set of options.
           *
           * @param {string} directive Name of the directive to be configured. Must be either 'tagsInput' or 'autoComplete'.
           * @param {object} options Object containing which options should have interpolation turned on at all times.
           *
           * @returns {object} The service itself for chaining purposes.
           */
          this.setActiveInterpolation = function (directive, options) {
              interpolationStatus[directive] = options;
              return this;
          };

          /**
           * @ngdoc method
           * @name tagsInputConfig#setTextAutosizeThreshold
           * @description Sets the threshold used by the tagsInput directive to re-size the inner input field element based on its contents.
           *
           * @param {number} threshold Threshold value, in pixels.
           *
           * @returns {object} The service itself for chaining purposes.
           */
          this.setTextAutosizeThreshold = function (threshold) {
              autosizeThreshold = threshold;
              return this;
          };

          this.$get = ["$interpolate", function ($interpolate) {
              var converters = {};
              converters[String] = function (value) {
                  return value;
              };
              converters[Number] = function (value) {
                  return parseInt(value, 10);
              };
              converters[Boolean] = function (value) {
                  return value.toLowerCase() === 'true';
              };
              converters[RegExp] = function (value) {
                  return new RegExp(value);
              };

              return {
                  load: function (directive, scope, attrs, options) {
                      var defaultValidator = function () {
                          return true;
                      };

                      scope.options = {};

                      angular.forEach(options, function (value, key) {
                          var type, localDefault, validator, converter, getDefault, updateValue;

                          type = value[0];
                          localDefault = value[1];
                          validator = value[2] || defaultValidator;
                          converter = converters[type];

                          getDefault = function () {
                              var globalValue = globalDefaults[directive] && globalDefaults[directive][key];
                              return angular.isDefined(globalValue) ? globalValue : localDefault;
                          };

                          updateValue = function (value) {
                              scope.options[key] = value && validator(value) ? converter(value) : getDefault();
                          };

                          if (interpolationStatus[directive] && interpolationStatus[directive][key]) {
                              attrs.$observe(key, function (value) {
                                  updateValue(value);
                                  scope.events.trigger('option-change', { name: key, newValue: value });
                              });
                          } else {
                              updateValue(attrs[key] && $interpolate(attrs[key])(scope.$parent));
                          }
                      });
                  },
                  getTextAutosizeThreshold: function () {
                      return autosizeThreshold;
                  }
              };
          }];
      });

      /***
       * @ngdoc service
       * @name tiUtil
       * @module ngTagsInput
       *
       * @description
       * Helper methods used internally by the directive. Should not be called directly from user code.
       */
      tagsInput.factory('tiUtil', ["$timeout", "$q", function ($timeout, $q) {
          var self = {};

          self.debounce = function (fn, delay) {
              var timeoutId;
              return function () {
                  var args = arguments;
                  $timeout.cancel(timeoutId);
                  timeoutId = $timeout(function () {
                      fn.apply(null, args);
                  }, delay);
              };
          };

          self.makeObjectArray = function (array, key) {
              if (!angular.isArray(array) || array.length === 0 || angular.isObject(array[0])) {
                  return array;
              }

              var newArray = [];
              array.forEach(function (item) {
                  var obj = {};
                  obj[key] = item;
                  newArray.push(obj);
              });
              return newArray;
          };

          self.findInObjectArray = function (array, obj, key, comparer) {
              var item = null;
              comparer = comparer || self.defaultComparer;

              array.some(function (element) {
                  if (comparer(element[key], obj[key])) {
                      item = element;
                      return true;
                  }
              });

              return item;
          };

          self.defaultComparer = function (a, b) {
              // I'm aware of the internationalization issues regarding toLowerCase()
              // but I couldn't come up with a better solution right now
              return self.safeToString(a).toLowerCase() === self.safeToString(b).toLowerCase();
          };

          self.safeHighlight = function (str, value) {
              if (!value) {
                  return str;
              }

              function escapeRegexChars(str) {
                  return str.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
              }

              str = self.encodeHTML(str);
              value = self.encodeHTML(value);

              var expression = new RegExp('&[^;]+;|' + escapeRegexChars(value), 'gi');
              return str.replace(expression, function (match) {
                  return match.toLowerCase() === value.toLowerCase() ? '<em>' + match + '</em>' : match;
              });
          };

          self.safeToString = function (value) {
              return angular.isUndefined(value) || value == null ? '' : value.toString().trim();
          };

          self.encodeHTML = function (value) {
              return self.safeToString(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
          };

          self.handleUndefinedResult = function (fn, valueIfUndefined) {
              return function () {
                  var result = fn.apply(null, arguments);
                  return angular.isUndefined(result) ? valueIfUndefined : result;
              };
          };

          self.replaceSpacesWithDashes = function (str) {
              return self.safeToString(str).replace(/\s/g, '-');
          };

          self.isModifierOn = function (event) {
              return event.shiftKey || event.ctrlKey || event.altKey || event.metaKey;
          };

          self.promisifyValue = function (value) {
              value = angular.isUndefined(value) ? true : value;
              return $q[value ? 'when' : 'reject']();
          };

          self.simplePubSub = function () {
              var events = {};
              return {
                  on: function (names, handler, first) {
                      names.split(' ').forEach(function (name) {
                          if (!events[name]) {
                              events[name] = [];
                          }
                          var method = first ? [].unshift : [].push;
                          method.call(events[name], handler);
                      });
                      return this;
                  },
                  trigger: function (name, args) {
                      var handlers = events[name] || [];
                      handlers.every(function (handler) {
                          return self.handleUndefinedResult(handler, true)(args);
                      });
                      return this;
                  }
              };
          };

          return self;
      }]);

      /* HTML templates */
      tagsInput.run(["$templateCache", function ($templateCache) {
          var tagInputHTML = `<div class="host" tabindex="-1" ng-click="eventHandlers.host.click()" ti-transclude-append>
        <div class="tags" ng-class="{focused: hasFocus}">
          <ul class="tag-list">
            <li class="tag-item"
                ng-repeat="tag in tagList.items track by track(tag)"
                ng-class="getTagClass(tag, $index)"
                ng-click="eventHandlers.tag.click(tag)">
              <ti-tag-item read-only="{{options.readOnly}}" scope="templateScope" data="::tag"></ti-tag-item>
            </li>
          </ul>
          <input class="input"
                 autocomplete="off"
                 ng-model="newTag.text"
                 ng-model-options="{getterSetter: true}"
                 ng-keydown="eventHandlers.input.keydown($event)"
                 ng-focus="eventHandlers.input.focus($event)"
                 ng-blur="eventHandlers.input.blur($event)"
                 ng-paste="eventHandlers.input.paste($event)"
                 ng-trim="false"
                 ng-class="{'invalid-tag': newTag.invalid}"
                 ng-hide="options.readOnly"
                 ti-bind-attrs="{type: options.type, placeholder: options.placeholder, tabindex: options.tabindex, spellcheck: options.spellcheck}"
                 ti-autosize>
        </div>
      </div>`;
          $templateCache.put('ngTagsInput/tags-input.html', tagInputHTML);

          $templateCache.put('ngTagsInput/tag-item.html', '<span ng-bind="$getDisplayText()"></span> <a class="remove-button" ng-hide="{{readOnly}}" ng-click="$removeTag()" ng-bind="::$$removeTagSymbol"></a>');

          var autoCompleteHTML = `<div class="autocomplete" ng-if="suggestionList.visible">
        <ul class="suggestion-list">
          <li class="suggestion-item"
              ng-repeat="item in suggestionList.items track by track(item)"
              ng-class="getSuggestionClass(item, $index)"
              ng-click="addSuggestionByIndex($index)"
              ng-mouseenter="suggestionList.select($index)">
            <ti-autocomplete-match scope="templateScope" data="::item"></ti-autocomplete-match>
          </li>
        </ul>
      </div>`;
          $templateCache.put('ngTagsInput/auto-complete.html', autoCompleteHTML);

          $templateCache.put('ngTagsInput/auto-complete-match.html', '<span ng-bind-html="$highlight($getDisplayText())"></span>');
      }]);
  })();

  /*
   * Included File: directives/debug.js
   */
  angular.module('idxCommon').directive("debug", ['$compile', function($compile) {
    return {
      terminal: true,
      priority: 100000,
      link: function(scope, element) {
        var clone = element.clone();
        element.attr("style", "color:red");
        clone.removeAttr("debug");
        var clonedEl = $compile(clone)(scope);
        element.after(clonedEl);
      }
    }
  }]);

  /*
   * Included File: directives/idxVisible.js
   */
  /**
   * Thanks to https://gist.github.com/c0bra/5859295
   */
  angular.module('idxCommon').directive('idxVisible', ['$log',function ($log) {
    return function (scope, element, attr) {
      scope.$watch(attr.idxVisible, function (visible) {
        $log.debug("visibility: " + visible);
        element.css('visibility', visible ? 'visible' : 'hidden');
      });
    };
  }]);

  /*
   * Included File: directives/idxPopover.js
   */
  /* global Modernizr */

  angular.module('idxCommon')
    .directive('idxPopover', ['$interval', '$window', function ($interval, $window) {
      return {
        restrict: 'A',
        scope: {
          options: "=idxPopover"
        },
        link: function ($scope, $element, attrs) {
          var options = {
            animation: false,
            html: false,
            placement: 'bottom',
            trigger: Modernizr.touch ? 'click' : 'hover',
            title: '',
            content: '',
            delay: 400,
            showOnlyWhenTooSmall: false
          };

          $interval(function () {
            _.extend(options, $scope.options);
            showPopover();
          }, 4000, 1);

          function showPopover() {
            $element.popover('destroy');
            $scope.$evalAsync(function () {
              if (options.showOnlyWhenTooSmall) {
                if ($element[0].scrollWidth > $element.innerWidth()) {
                  $element.popover(options);
                }
              } else {
                $element.popover(options);
              }
            });
          }

          angular.element($window).resize(showPopover)
        }
      }
    }]);


  /*
   * Included File: IdxModal.js
   */
  /***** JSLint Config *****/
  /*global angular, getTemplateStr  */

  angular.module('idxCommon')

  .factory('IdxModal', [
    '$compile',
    '$rootScope',
    '$q',
    '$interval',
    function(
      $compile,
      $rootScope,
      $q,
      $interval) {

      var $scope;

      var Modal = function() {
        this.scope = $scope = $rootScope.$new(true);
        this.config = {};
        this.element = null;
        // TODO: Find a permanent solution to prevent error messages from being overwritten
        this.lock = false;
      }


      /*
        For info on config object, see templates/idxCommonModal.html
      */
      Modal.prototype.create = function(config) {
        initialize();
        angular.extend(this.config, config);
        var inputs = [this.config.fields, this.config.elements];
        addInputs(inputs);
        var modal = angular.element(getTemplateStr('idxCommonModal'));
        this.element = $compile(modal)(this.scope);
        angular.element(document.body).append(this.element);
        addClose();
        return this;
      }

      Modal.prototype.close = function() {
        var d = $q.defer();
        return d.promise;
      }

      Modal.prototype.show = function(conf) {
        $interval(function() {
          $scope.$broadcast('show', conf);
        }, 0, 1);
        return this;
      }

      Modal.prototype.hide = function() {
        this.scope.$broadcast('hide');
        return this;
      }

      Modal.prototype.spinner = {
        show: function() {
          $scope.$broadcast('showSpinner');
          return this;
        },
        hide: function() {
          $scope.$broadcast('hideSpinner');
          return this;
        }
      }

      Modal.prototype.update = function(config) {
        this.config = config;
        var inputs = [config.fields, config.elements];
        if (config.reinitialize) initialize();
        addClose();
        addInputs(inputs);
        return this;
      }

      Modal.prototype.setHeading = function(heading) {
        $scope.heading = heading;
        return this;
      }

      Modal.prototype.setBody = function(body) {
        $scope.body = body;
        return this;
      }

      Modal.prototype.setSecureBody = function(secureBody) {
        $scope.secureBody = secureBody;
        return this;
      }

      Modal.prototype.setTryAgainButton = function(tryAgainButton) {
        $scope.tryAgainButton = tryAgainButton;
        return this;
      }

      Modal.prototype.setHideModal = function(hideModal) {
        $scope.hideModal = hideModal;
        return this;
      }

      Modal.prototype.setLeftFooterLink = function(leftFooterLink) {
        $scope.leftFooterLink = leftFooterLink;
        return this;
      }

      Modal.prototype.setRightFooterLink = function(rightFooterLink) {
        $scope.rightFooterLink = rightFooterLink;
        return this;
      }

      Modal.prototype.setPrimaryButton = function(primaryButton) {
        $scope.primaryButton = primaryButton;
        return this;
      }

      Modal.prototype.injectDirective = function(directive) {
        // TODO: why are there 3 identical modals that are being manipulated together, then only one is shown?
        // ANSWER: because this creates and attaches a new modal element each time create is called. If it is
        // called once on the page, there should be only one. Note it can be called by any controller, service
        // or directive. Each controller, service or directive should take care of creating and cleaning up the
        // modals it creates. The destroy method has been updated to destroy the specific modal created by create().
        // TODO: change this so that this injection happens after the modal has been updated for project instructions and the selectors can be less generic
        var injectionPoint = this.element.find('.injection-point');
        injectionPoint.append(directive);
        $scope.$evalAsync(function() {
          $scope.directiveInjected = true;
        });
        return this;
      }

      Modal.prototype.destroy = function() {
        this.hide();
        this.element.remove();
        this.scope = null;
      }

      function initialize() {
        var inputs = [
          'closeButton',
          'modalClass',
          'body',
          'secureBody',
          'directiveInjected',
          'tryAgainButton',
          'hideModal',
          'leftFooterLink',
          'rightFooterLink',
          'cancelLink',
          'okButton',
          'primaryButton'
        ];
        angular.forEach(inputs, function(input) {
          delete $scope[input]
        });
      }

      function addInputs(inputs) {
        angular.forEach(inputs, function(input) {
          for (var prop in input) {
            $scope[prop] = input[prop];
          }
        });
      }

      function addClose() {
        var d = $q.defer();
        Modal.prototype.close = d.promise;
        $scope.close = function(result, delay) {
          $interval(function() {
            d.resolve(result);
            $scope.$broadcast('hide');
          }, delay || 0, 1);
        };
      }

      return Modal;
    }
  ])

  .service('internalModalService', [function() {
    this.position = null;

    this.registerModal = function(modal) {
      this.modal = modal;
    };

    this.getModal = function() {
      return this.modal;
    }

    return this;
  }])

  .directive('idxCommonModal', ['keyboardManager', 'internalModalService', function(keyboardManager, srvc) {
    return {
      restrict: 'E',
      scope: true,
      link: function($scope, $element, attrs) {

        $element.on('click', "a[href^='#']", function(event) {
          var name = event.currentTarget.hash.replace('#','');
          var $target = $element.find("a[name='" + name + "']");
          if ($target.length > 0) $target.get(0).scrollIntoView();
          event.preventDefault();
        });

        $scope.$on('show', function(event, conf) {
          var config = {
            show: true
          }
          angular.extend(config, conf);
          $element.modal(config);
          $element
            .removeClass('fade')
            .removeClass('in')
            .removeClass('hide')
            .css("display", "block");
        });

        keyboardManager.registerKeyboardShortcut('esc', function (shortcut, e) {
          // TODO: we need to eventually get these working with bootstrap.
          angular.element('idx-common-modal').modal('hide');
          angular.element('.fs-modal .modal-header .fs-dialog__close').click();
          angular.element('#batch-alert .fs-dialog__close').click();
        });

        $scope.$on('hide', function() {
          $element.modal('hide');
          //$('.modal-backdrop').remove(); // TODO: breaks layered modals, dismissing top modal removes the bottom modal's backdrop
        });
      }
    }
  }])

  .directive('idxModalSpinner', [function() {
    "use strict";
    return function($scope, $el) {

      $el.hide();

      $scope.$on('showSpinner', function() {
        $el.show();
      });

      $scope.$on('hideSpinner', function() {
        $el.hide();
      });

    };
  }])

  .directive('idxSecureModalContent', [function() {
    return {
      transclude: true,
      link: function($scope, $element) {
        $element.on('click', "a[href^='#']", function(event) {
          event.preventDefault();
          var targetElementToDisplay = $($(event.currentTarget).attr('href'));
          if (targetElementToDisplay.length > 0) targetElementToDisplay[0].scrollIntoView(true);
        });
      }
    }
  }]);


  /*
   * Included File: idxConsentModalService.js
   */
  /* global angular, getTemplateStr */

  angular.module('idxCommon')

  .factory('idxConsentModalService', [
    'IdxModal',
    'UserModel',
    '$compile',
    '$sce',
  	'$q',
    '$rootScope',
    '$window',
    '$log',
    function(
      IdxModal,
      UserModel,
      $compile,
      $sce,
  		$q,
      $rootScope,
      $window,
      $log
    ) {
      var service = {};
      var $scope = $rootScope.$new(true);
  		var modal = new IdxModal().create();
      var overview = FS.appPath + '/';
      $scope.indexingTerms = FS.appPath + '/terms';
      $scope.contentSubmission = FS.appPath + '/submission-agreement';

      service.checkOnboardingAcceptance = function(returnObj) {
        if (!FS.showEx('onboardingEx')) return $q.when(returnObj);

        $rootScope.$broadcast('EVENT:interrupt_spinner');
        return UserModel.hasAcceptedRequiredAgreements()
          .then(function(answer) {
            if (!answer) return service.showConsentModal(returnObj);
            else $rootScope.$broadcast('EVENT:restart_spinner'); return $q.when(returnObj);
          }).catch(function(error) { //Don't show modal something went wrong
            $rootScope.$broadcast('EVENT:restart_spinner'); return $q.when(returnObj);
            $log.error({data: error, display: false, stackTrace: (new Error()).stack});
          });
      }

      service.showConsentModal = function(returnObj) {
        var d = $q.defer();
        var bodyHtml = angular.element(getTemplateStr('idxTermsAndConditionsModal'));
        var directive = $compile(bodyHtml)($scope);
        modal.injectDirective(directive);
        modal.update({
          reinitialize: true,
          fields: {
            modalClass: 'medium',
            heading: lang['accept-terms-and-conditions'],
            headerClass: 'fs-modal__header',
            bodyClass: 'fs-modal__body',
            footerClass: 'fs-modal__buttons'
          },
          elements: {
            cancelLink: {
              include: true,
              text: lang['not-accept'],
              cssClass: 'fs-button--minor',
              handler: function() {
                modal.update({
                  elements: {
                    cancelLink: {
                      include: true,
                      text: lang['exit_to_overview'],
                      handler: function() {
                        return $window.location.href = overview;
                      }
                    }
                  }
                });
                $scope.showAcceptanceAlert = true;
              }
            },
            primaryButton: {
              include: true,
              text: lang['accept'],
              cssClass: 'fs-button--small fs-button--recommended',
              handler: function() {
                return UserModel.updateAgreementStatus()
                  .then(function(data) {
                    modal.hide();
                    d.resolve(returnObj);
                    $rootScope.$broadcast('EVENT:restart_spinner');
                  }, function(err) {
                    $log .debug('error', err);
                    modal.update({
                      reinitialize: true,
                      fields: {
                        heading: lang['updating_user_resource_error_heading'],
                        body: lang['updating_user_resource_error_body'],
                        alertClass: 'fs-alert fs-alert--error',
                        headerClass: '',
                        bodyClass: 'fs-alert-body',
                        footerClass: 'fs-alert-footer'
                      },
                      elements: {
                        primaryButton: {
                          include: true,
                          text: lang['okay'],
                          handler: function() {
                            modal.spinner.show();
                            return $window.location.href = overview;
                          }
                        }
                      }
                  })
                });
              }
            }
          }
        });

        modal.show({
          keyboard: true,
          backdrop: 'static'
        });
        return d.promise;
      };

      return service;
    }
  ])

  // .directive('idxTermsAndConditionsModalBody', [function() {
  //   return function($scope, $element, attrs) {
  //     }
  //   }
  // ]);


})(window, document);


// Sub-assembly: UsabillaProblem
(function(window, document, undefined) {

  var langKeys = ["title","description"];
  var langs = {
    // Included locale file: UsabillaProblem_de.json
    "de": ["Ein Problem melden","Ich möchte ein Problem melden, auf das ich gestoßen bin."],
    // Included locale file: UsabillaProblem_en.json
    "en": ["Report a Problem","I’d like to report a problem I encountered."],
    // Included locale file: UsabillaProblem_eo.json
    "eo": ["[Ŕéþöŕţ å Þŕöƀļéɱ--------- П國カ내]","[Î’ð ļîķé ţö ŕéþöŕţ å þŕöƀļéɱ Î éñçöûñţéŕéð.------------------ П國カ내]"],
    // Included locale file: UsabillaProblem_es.json
    "es": ["Informar de un problema","Me gustaría informar sobre un problema que encontré."],
    // Included locale file: UsabillaProblem_fr.json
    "fr": ["Signaler un problème","J’aimerais signaler un problème rencontré."],
    // Included locale file: UsabillaProblem_it.json
    "it": ["Segnala un problema","Desidero segnalare un problema che ho riscontrato."],
    // Included locale file: UsabillaProblem_ja.json
    "ja": ["問題を報告する","わたしが遭遇した問題を報告します。"],
    // Included locale file: UsabillaProblem_nl.json
    "nl": ["Een probleem melden","Ik wil een probleem melden waar ik op stuitte."],
    // Included locale file: UsabillaProblem_pl.json
    "pl": ["Zgłoś problem","Chcę zgłosić napotkany problem."],
    // Included locale file: UsabillaProblem_pt.json
    "pt": ["Informar um Problema","Gostaria de informar um problema que encontrei."],
    // Included locale file: UsabillaProblem_ru.json
    "ru": ["Сообщить о проблеме","Я хотел бы сообщить об обнаруженной мною проблеме."],
    // Included locale file: UsabillaProblem_sv.json
    "sv": ["Rapportera ett problem","Jag vill rapportera ett problem som jag stötte på."],
  };
  var validLocales = ["de","en","eo","es","fr","it","ja","ke","nl","pl","pt","ru","sv","zz"];

  function getLang(locales) {
    var locale, language, i, len = langKeys.length, lang = {};
    locales = (typeof locales === 'string' ? [locales] : locales);
    for (i = 0; i < locales.length; i++) {
      language = locales[i];
      if (validLocales.indexOf(language) !== -1) {
        locale = language;
        break;
      } else {
        //Check if the first two characters are a valid locale
        language = locales[i].split('-')[0];
        if (validLocales.indexOf(language) !== -1) {
          locale = language;
          break;
        }
      }
    }
    locale = locale || 'en';
    var temp;
    switch (locale) {
      case 'ke':
      case 'zz':
        for(i = 0; i < len; i++) {
          temp = (locale === 'ke' ? '[' + langKeys[i] + ']' : '[UsabillaProblem.' + langKeys[i] + ']');
          lang[langKeys[i]] = temp;
        }
        break;

      default:
        for(i = 0; i < len; i++) {
          lang[langKeys[i]] = langs[locale][i];
        }
        break;
    }
    return lang;
  }

  var lang = getLang(FS.simpleLocale() || 'en');

  var templateList = {
    // Included template file: templates/template.html
    "template": '<div class="choice choice_specific report_a_problem" tabindex="0" data-test="usabillaProblem"> <div class="report" style="width: 32px; height: 32px; position: absolute; left: 17px; top: 16px; background-repeat: no-repeat;"></div> <h4>{title}</h4> <span>{description}</span> </div>'
  };

  function getTemplateStr(key) {
    if (!templateList[key]) {
      console.warn("No template named '" + key + "'");
    }

    return __gca_formatStr(templateList[key] || "", lang);
  }

  var __gca_formatStrRe = /{([^}]+)}/g;
  function __gca_formatStr(txt, obj) {
  var potentialSubstitutionsRegex = /{+?[^{\n\r]+}/g;
  var trueSubstitutionsRegex = /^{([^{}]+)}/;
  if (typeof obj !== "object") {
  obj = Array.prototype.slice.call(arguments, 1);
  }
  return txt.replace(potentialSubstitutionsRegex, function (fullKey) {
  return fullKey.replace(trueSubstitutionsRegex, function(match, key) {
  var ObjArray = key.split(".");
  var len = ObjArray.length;
  var tempObj = obj;
  for (var i = 0; i < len; i++) {
  tempObj = tempObj[ObjArray[i]];
  if (!tempObj) {
  return match;
  }
  }
  return tempObj;
  });
  });
  }

  function getTemplate(key) {
    var snip = document.createElement("div");
    snip.innerHTML = getTemplateStr(key);
    if (snip.children.length > 1) { 
      throw new Error("template '" + key + "' must have exactly one root element");
    }
    return snip.firstChild;
  }

  /*
   * Included File: UsabillaProblem.js
   */
  /*global angular*/

  var usabillaModule = angular.module('UsabillaProblem', [])

    .directive('usabillaProblem', function() {

    var usabillaObject = {

      restrict : 'A',

      replace: true,

      template: getTemplateStr('template')

    };

    return usabillaObject;

  });



})(window, document);


// Sub-assembly: UsabillaFeedback
(function(window, document, undefined) {

  var langKeys = ["feedback"];
  var langs = {
    // Included locale file: UsabillaFeedback_de.json
    "de": ["Feedback"],
    // Included locale file: UsabillaFeedback_en.json
    "en": ["Feedback"],
    // Included locale file: UsabillaFeedback_eo.json
    "eo": ["[Ƒééðƀåçķ--------- П國カ내]"],
    // Included locale file: UsabillaFeedback_es.json
    "es": ["Comentarios"],
    // Included locale file: UsabillaFeedback_fr.json
    "fr": ["Commentaires"],
    // Included locale file: UsabillaFeedback_it.json
    "it": ["Feedback"],
    // Included locale file: UsabillaFeedback_ja.json
    "ja": ["フィードバック"],
    // Included locale file: UsabillaFeedback_ko.json
    "ko": ["피드백"],
    // Included locale file: UsabillaFeedback_nl.json
    "nl": ["Feedback"],
    // Included locale file: UsabillaFeedback_pl.json
    "pl": ["Uwagi"],
    // Included locale file: UsabillaFeedback_pt.json
    "pt": ["Comentários"],
    // Included locale file: UsabillaFeedback_ru.json
    "ru": ["Отзывы"],
    // Included locale file: UsabillaFeedback_sv.json
    "sv": ["Feedback"],
    // Included locale file: UsabillaFeedback_zh.json
    "zh": ["意見回饋"],
  };
  var validLocales = ["de","en","eo","es","fr","it","ja","ke","ko","nl","pl","pt","ru","sv","zh","zz"];

  function getLang(locales) {
    var locale, language, i, len = langKeys.length, lang = {};
    locales = (typeof locales === 'string' ? [locales] : locales);
    for (i = 0; i < locales.length; i++) {
      language = locales[i];
      if (validLocales.indexOf(language) !== -1) {
        locale = language;
        break;
      } else {
        //Check if the first two characters are a valid locale
        language = locales[i].split('-')[0];
        if (validLocales.indexOf(language) !== -1) {
          locale = language;
          break;
        }
      }
    }
    locale = locale || 'en';
    var temp;
    switch (locale) {
      case 'ke':
      case 'zz':
        for(i = 0; i < len; i++) {
          temp = (locale === 'ke' ? '[' + langKeys[i] + ']' : '[UsabillaFeedback.' + langKeys[i] + ']');
          lang[langKeys[i]] = temp;
        }
        break;

      default:
        for(i = 0; i < len; i++) {
          lang[langKeys[i]] = langs[locale][i];
        }
        break;
    }
    return lang;
  }

  var lang = getLang(FS.simpleLocale() || 'en');

  var templateList = {
    // Included template file: templates/template.html
    "template": '<button data-test="usabillaFeedback">{feedback}</button>'
  };

  function getTemplateStr(key) {
    if (!templateList[key]) {
      console.warn("No template named '" + key + "'");
    }

    return __gca_formatStr(templateList[key] || "", lang);
  }

  var __gca_formatStrRe = /{([^}]+)}/g;
  function __gca_formatStr(txt, obj) {
  var potentialSubstitutionsRegex = /{+?[^{\n\r]+}/g;
  var trueSubstitutionsRegex = /^{([^{}]+)}/;
  if (typeof obj !== "object") {
  obj = Array.prototype.slice.call(arguments, 1);
  }
  return txt.replace(potentialSubstitutionsRegex, function (fullKey) {
  return fullKey.replace(trueSubstitutionsRegex, function(match, key) {
  var ObjArray = key.split(".");
  var len = ObjArray.length;
  var tempObj = obj;
  for (var i = 0; i < len; i++) {
  tempObj = tempObj[ObjArray[i]];
  if (!tempObj) {
  return match;
  }
  }
  return tempObj;
  });
  });
  }

  function getTemplate(key) {
    var snip = document.createElement("div");
    snip.innerHTML = getTemplateStr(key);
    if (snip.children.length > 1) { 
      throw new Error("template '" + key + "' must have exactly one root element");
    }
    return snip.firstChild;
  }

  /*
   * Included File: UsabillaFeedback.js
   */
  /*global angular*/

  var usabillaModule = angular.module('UsabillaFeedback', [])

    .directive('usabillaFeedback', function() {

    var usabillaObject = {

      restrict : 'A',

      replace: true,

      template: getTemplateStr('template')

    };

    return usabillaObject;

  });



})(window, document);
